import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
} from "@mui/material";
import {
  Add,
  Delete,
  DeleteOutline,
  Download,
  FilterList,
  MoreVert,
  Search,
  FirstPage,
  LastPage,
  Remove,
  GridOn,
  CloudUpload,
  Close,
  PhotoCamera,
} from "@mui/icons-material";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  getBidding,
  biddingSearchParams,
  createBidding,
  uploadItemPhoto,
  deleteBidding,
  updateBidding,
  fetchBidding,
  getBiddingById,
  fetchBiddingPhotoBlob,
  createBiddingLocation,
  fetchVendors,
  uploadProposal,
  getProposalFile,
  deleteProposalFile,
  getRabDetailsByRabId,
  getRabDetail,
  fetchAhs,
  createBiddingAdjustment,
  createBiddingAdjustments,
  getBiddingAdjustmentsByRabId,
  updateBiddingAdjustment,
  deleteBiddingAdjustment,
  BiddingAdjustmentData,
  viewBiddingAdjustment,
} from "../services/biddingProcessService.tsx";
import { getAllProjects } from "../services/projectListingService.tsx";
import { RABSearchParams, getRab } from "../services/rabService.tsx";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AddIcon from "@mui/icons-material/Add";
import {
  LocationSearchParams,
  getLocations,
  createLocation,
  editLocation,
  deleteLocation,
} from "../../data_management/services/locationService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface Bidding {
  projectName: string;
  rabName: string; // Perbaiki typo dari biddingNameame
  rabValue: string;
  submissionDate: string;
  clientName: string;
  projectType: string;
  constructionPhase: string;
  projectProcess: string;
  vendorNames: string;
  status: string;
}

interface Vendor {
  vendorId: string;
  vendorName: string; // Perbaiki typo dari vendorNameame
  vendorAddress: string;
  vendorContactNumber: string;
  vendorEmail: string;
  vendorType: string;
  vendorTaxId: string;
  vendorBankDetails: string;
  vendorStatus: string;
  photoVendor?: string; // Tambahkan field untuk foto
}

interface RabOption {
  id: string;
  rabName: string;
  totalPrice: string;
  project: {
    id: string;
    projectName: string;
    projectReferenceId: string;
    startDate: string;
    endDate: string;
    // Tambahkan field lain yang diperlukan
  };
}

interface ProjectOption {
  id: string;
  projectName: string;
  // tambahkan field lain jika diperlukan
  projectReferenceId; // Map to projectReferenceId
  source: string;
  projectType: string;
  constructionPhase: string;
  projectAddress: string;
  latitude: string;
  longitude: string;
  region: string;
  province: string;
  city: string;
  district: string;
}

interface RABApiResponse {
  total: number;
  data: {
    id: string;
    rabName: string;
    totalPrice: string;
    project: {
      id: string;
      projectName: string;
      projectReferenceId: string;
      startDate: string;
      endDate: string;
    };
  }[];
  pagination: {
    limit: number;
    offset: number;
    currentPage: number;
    totalPages: number;
  };
}

interface RabDetail {
  id: string;
  rabId: string;
  ahsId: string;
  volume: string | number;
  totalHarga: string | number;
  hargaSatuan: string | number;
  satuanAHS: string;
  category: string;
  namaAHS: string;
  overheadKoefisien: number;
  ahs?: {
    hargaSatuan?: string;
    overheadKoefisien?: string;
    totalJumlahHargaABC?: string;
  };
  baseHargaSatuan?: number;
  isSelected?: boolean;
  hasCustomCoefficient?: boolean;
  customCoefficient?: number;
}

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Bidding[]) => void;
}

const BiddingListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddBiddingDialog, setOpenAddBiddingDialog] = useState(false);
  const [openEditBiddingDialog, setOpenEditBiddingDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingBank, setLoadingloadingBank] = useState(false);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman
  const [projectOptions, setProjectOptions] = useState<ProjectOption[]>([]);
  const [rabOptions, setRabOptions] = useState<RabOption[]>([]);
  const [loadingRabs, setLoadingRabs] = useState(false);
  const [biddingAdjustments, setBiddingAdjustments] = useState<any[]>([]);
  const [loadingAdjustments, setLoadingAdjustments] = useState(false);
  const [adjustmentTotalPrices, setAdjustmentTotalPrices] = useState<{
    [key: string]: number;
  }>({});
  const [adjustmentUnitPrices, setAdjustmentUnitPrices] = useState<{
    [key: string]: number;
  }>({});

  // Tambahkan state ini di komponen utama
  const [itemCoefficientsAdd, setItemCoefficientsAdd] = useState<{
    [key: string]: number;
  }>({});
  const [itemCoefficientsEdit, setItemCoefficientsEdit] = useState<{
    [key: string]: number;
  }>({});

  const displayedRows = rows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  // Fungsi untuk mengambil data bidding

  // Bidding Data Table ========================================================================
  // Fungsi untuk mengambil data bidding
  const reloadBidding = async () => {
    setIsLoading(true);
    setError("");
    try {
      const result = await getBidding({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });
      setRows(result.data);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err) {
      console.error("Reload error:", err);
      setError(err.message);
      throw err; // Re-throw
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRabs = async (): Promise<void> => {
    setLoadingRabs(true);
    try {
      const result = await getRab(); // Menggunakan getRab existing tanpa modifikasi

      // Type assertion ke RABApiResponse
      const apiResponse = result as unknown as RABApiResponse;

      if (!apiResponse?.data || !Array.isArray(apiResponse.data)) {
        throw new Error(
          "Invalid RAB data format: Expected array in data property"
        );
      }

      const mappedOptions: RabOption[] = apiResponse.data.map((item) => ({
        id: item.id,
        rabName: item.rabName,
        totalPrice: item.totalPrice,
        project: {
          id: item.project.id,
          projectName: item.project.projectName,
          projectReferenceId: item.project.projectReferenceId,
          startDate: item.project.startDate,
          endDate: item.project.endDate,
        },
      }));

      setRabOptions(mappedOptions);
    } catch (error: any) {
      console.error("Error resetting filters:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Gagal mereset filter",
      });
    } finally {
      setLoadingRabs(false);
    }
  };

  const fetchProjectList = async () => {
    try {
      const result = await getAllProjects();
      setProjectOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    projectName?: string;
    rabName?: string;
    rabValue?: string;
    submissionDate?: string;
    clientName?: string;
    projectType?: string;
    constructionPhase?: string;
    projectProcess?: string;
    vendorNames?: string;
    status?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  const [rabReviewDataEdit, setRabReviewDataEdit] = useState<RabDetail[]>([]);

  const [totalRabValue, setTotalRabValue] = useState(0);
  const [loadingRabReview, setLoadingRabReview] = useState(false);

  const fetchRabReview = async (rabId: string) => {
    if (!rabId) return;

    setLoadingRabReview(true);
    try {
      const result = await getRabDetailsByRabId(rabId);

      // Normalize data and ensure numeric values
      const rabDetailsWithAHS = result.data.map((detail): RabDetail => {
        const ahsDetail = ahsOptions.find((ahs) => ahs.id === detail.ahsId);

        // PERBAIKAN: Simpan harga dasar AHS dan harga dengan overhead
        const hargaDasarAHS = ahsDetail?.totalJumlahHargaABC
          ? parseFloat(ahsDetail.totalJumlahHargaABC)
          : parseFloat(detail.hargaSatuan || "0") /
            (1 + (detail.overheadKoefisien || 0.1));

        const overheadKoefisien = parseFloat(
          detail.ahs?.overheadKoefisien || "0.1"
        );
        const volume = parseFloat(detail.volume || "0");

        const hargaDenganOverhead = hargaDasarAHS * (1 + overheadKoefisien);
        const totalDenganOverhead = hargaDenganOverhead * volume;

        return {
          ...detail,
          category: ahsDetail?.category || detail.category || "",
          hargaSatuan: hargaDenganOverhead, // Harga sudah termasuk overhead default
          totalHarga: totalDenganOverhead,
          satuanAHS: ahsDetail?.satuanAHS || detail.satuanAHS || "",
          namaAHS: ahsDetail?.namaAHS || detail.namaAHS || "",
          volume: volume,
          overheadKoefisien: overheadKoefisien,
          baseHargaSatuan: hargaDasarAHS, // Simpan harga dasar untuk referensi
        };
      });

      setRabReviewDataEdit(rabDetailsWithAHS);
      setAdjustedRabReviewDataEdit(rabDetailsWithAHS);

      // Calculate total awal
      const total = rabDetailsWithAHS.reduce(
        (acc, curr) => acc + (curr.totalHarga || 0),
        0
      );

      setTotalRabValue(total);
    } catch (error) {
      console.error("Failed to fetch RAB review:", error);
      setRabReviewDataEdit([]);
      setAdjustedRabReviewDataEdit([]);
      setTotalRabValue(0);
    } finally {
      setLoadingRabReview(false);
    }
  };

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadBidding();
    fetchProjectList();
    fetchAhsList();
    fetchRabs();
    fetchBiddingAdjustments();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteBidding = async (confirm = true) => {
    try {
      const confirmDelete = confirm
        ? await Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Anda tidak dapat mengembalikan data yang dihapus!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
          })
        : { isConfirmed: true };

      if (!confirmDelete.isConfirmed) return;

      const rowsToDelete = [...selectedRows];

      // Hapus bidding adjustment terlebih dahulu untuk setiap bidding yang akan dihapus
      for (const id of rowsToDelete) {
        try {
          // Dapatkan data bidding untuk mendapatkan rabId
          const biddingData = await getBiddingById(String(id));

          if (biddingData && biddingData.rabId) {
            try {
              // Dapatkan semua bidding adjustment untuk rabId ini
              const adjustments = await getBiddingAdjustmentsByRabId(
                biddingData.rabId
              );

              // PERBAIKAN: Gunakan ID adjustment yang benar untuk delete
              if (adjustments.data && Array.isArray(adjustments.data)) {
                for (const adjustment of adjustments.data) {
                  // Gunakan adjustment.id (bukan rabDetailId)
                  await deleteBiddingAdjustment(adjustment.id);
                }
              } else if (Array.isArray(adjustments)) {
                for (const adjustment of adjustments) {
                  // Gunakan adjustment.id (bukan rabDetailId)
                  await deleteBiddingAdjustment(adjustment.id);
                }
              }
            } catch (adjustmentError) {
              console.warn(
                `Gagal menghapus bidding adjustment untuk bidding ${id}:`,
                adjustmentError
              );
              // Lanjutkan proses penghapusan meskipun gagal hapus adjustment
            }
          }
        } catch (biddingError) {
          console.warn(`Gagal mendapatkan data bidding ${id}:`, biddingError);
          // Lanjutkan proses penghapusan meskipun gagal mendapatkan data bidding
        }
      }

      // Hapus bidding itu sendiri
      await Promise.all(rowsToDelete.map((id) => deleteBidding(String(id))));
      await Swal.fire({
        icon: "success",
        title: "Bidding berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });
      await reloadBidding();

      setSelectedRows([]);
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus bidding",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "projectName", value: "" }]);
  const [biddings, setBiddings] = useState<Bidding[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "projectName", label: "Project Name" },
    { value: "rabName", label: "RAB Name" },
    { value: "rabValue", label: "Bid Ammount" },
    { value: "submissionDate", label: "Submission Date" },
    { value: "clientName", label: "Source" },
    { value: "projectType", label: "Type" },
    { value: "constructionPhase", label: "Phase" },
    { value: "projectProcess", label: "Project Process" },
    { value: "vendorNames", label: "Vendor Names" },
    { value: "status", label: "Bidding Status" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: biddingSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "projectName", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  const [uniqueValues, setUniqueValues] = useState<{
    projectName: string[];
    rabName: string[];
    vendorNames: string[];
  }>({
    projectName: [],
    rabName: [],
    vendorNames: [],
  });

  const [selectedRabItemsAdd, setSelectedRabItemsAdd] = useState<string[]>([]);
  const [selectedRabItemsEdit, setSelectedRabItemsEdit] = useState<string[]>(
    []
  );
  const [adjustedRabReviewDataAdd, setAdjustedRabReviewDataAdd] = useState<
    RabDetail[]
  >([]);
  const [adjustedRabReviewDataEdit, setAdjustedRabReviewDataEdit] = useState<
    RabDetail[]
  >([]);

  // Fungsi untuk mengumpulkan nilai unik dari data
  useEffect(() => {
    if (biddings.length > 0) {
      const projectNames = [...new Set(biddings.map((b) => b.projectName))];
      const rabNames = [...new Set(biddings.map((b) => b.rabName))];
      const vendorNames = [
        ...new Set(biddings.flatMap((b) => b.vendorNames || [])),
      ];

      setUniqueValues({
        projectName: projectNames,
        rabName: rabNames,
        vendorNames: vendorNames,
      });
    }
  }, [biddings]);

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getBidding({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatBiddingForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one bidding to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.biddingId))
      //   .map(formatBiddingForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Biddings");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Biddings_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: error.message || "Failed to export bidding data",
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allBiddings = await getBidding({
      ...filterParams,
      limit: 10000, // Get all data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    // Helper function to format empty values
    const formatEmpty = (value: any) => (value ? value : "-");

    // Helper function to format currency
    const formatCurrency = (value: string | number) => {
      const num = typeof value === "string" ? parseFloat(value) : value;
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(num);
    };

    const formatNumber = (value) => {
      if (value === null || value === undefined) return "";
      const num = Number(value);
      if (isNaN(num)) return value;
      return num.toString().replace(/,/g, "."); // Replace comma with dot
    };

    // Helper function to format date
    const formatDate = (dateString: string) => {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
    };

    // Transform data for export
    return allBiddings.data.map((bidding) => {
      // Find project and vendor details
      const project = projectOptions.find(
        (proj) => proj.id === bidding.projectName
      );
      const vendorNames = Array.isArray(bidding.vendorNames)
        ? bidding.vendorNames
            .map(
              (vendorId) =>
                vendors.find((v) => v.vendorId === vendorId)?.vendorName ||
                vendorId
            )
            .join(", ")
        : vendors.find((v) => v.vendorId === bidding.vendorNames)?.vendorName ||
          bidding.vendorNames;

      const vendorValues = Array.isArray(bidding.vendorProjectValue)
        ? bidding.vendorProjectValue.join(", ")
        : bidding.vendorProjectValue;

      return {
        // Project Information
        "Project Name": formatEmpty(
          project?.projectName || bidding.projectName
        ),
        "Client Name": formatEmpty(bidding.clientName),
        "Project ID": formatEmpty(bidding.projectId),
        "Project Type": formatEmpty(bidding.projectType),
        "Construction Phase": formatEmpty(bidding.constructionPhase),
        "Project Location": formatEmpty(bidding.projectLocation),

        // RAB Information
        "RAB Name": formatEmpty(
          rabOptions.find((rab) => rab.id === bidding.rabName)?.rabName ||
            bidding.rabName
        ),
        "RAB Value": formatNumber(bidding.rabValue),
        "Start Date": formatDate(bidding.startDate),
        "End Date": formatDate(bidding.endDate),

        // Bidding Information
        "Submission Date": formatDate(bidding.submissionDate),
        "Project Process": formatEmpty(bidding.projectProcess),
        "Vendor Names": formatEmpty(vendorNames),
        "Vendor Project Values": formatEmpty(vendorValues),
        Status: formatEmpty(bidding.status),

        // Dates
        "Created At": formatDate(bidding.createdAt),
        "Updated At": formatDate(bidding.updatedAt),
      };
    });
  };

  // Fungsi untuk memformat data bidding untuk export
  const formatBiddingForExport = (bidding) => ({
    biddingId: bidding.biddingId,
    biddingNameame: bidding.biddingNameame,
    biddingAddress: bidding.biddingAddress,
    biddingType: bidding.biddingType,
    biddingContactNumber: bidding.biddingContactNumber,
    biddingEmail: bidding.biddingEmail,
    biddingStatus: bidding.biddingStatus,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  // add bidding data ========================================================================
  const [biddingDataAdd, setBiddingDataAdd] = useState<{
    id: string;
    projectListingId: string;
    projectName: string;
    clientName: string;
    rabId: string;
    projectId: string;
    projectType: string;
    constructionPhase: string;
    rabName: string;
    bidAmount: number;
    submissionDate: Date | null;
    projectAddress: string;
    rabValue: number;
    startDate: string;
    endDate: string;
    projectProcess: string;
    vendorNames: any[];
    vendorProjectValue: any[];
    status: string;
    biddingRegion: string;
    biddingCity: string;
    biddingDistrict: string;
    koefisien: number;
    latitude: string;
    longitude: string;
    file: File | null;
  }>({
    id: "",
    projectListingId: "",
    projectName: "",
    clientName: "",
    rabId: "",
    projectId: "",
    projectType: "",
    constructionPhase: "",
    rabName: "",
    bidAmount: 0,
    submissionDate: null,
    projectAddress: "",
    rabValue: 0,
    startDate: "",
    endDate: "",
    projectProcess: "",
    vendorNames: [""],
    vendorProjectValue: [""],
    status: "",
    biddingRegion: "",
    biddingCity: "",
    biddingDistrict: "",
    koefisien: 0,
    latitude: "",
    longitude: "",
    file: null,
  });

  const nullProject = {
    id: "",
    source: "",
    projectListingId: "",
    projectName: "",
    projectAddress: "",
    rabId: "",
    projectId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  };

  const nullRab = {
    id: "",
    rabName: "",
    totalPrice: "",
    projectId: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  };

  const [projectAdd, setProjectAdd] = useState<{
    id: string;
    source: string;
    projectListingId: string;
    projectName: string;
    projectAddress: string;
    projectId: string;
    city: string;
    region: string;
    district: string;
    latitude: string;
    longitude: string;
    constructionPhase: string;
    salesProjectId: string;
    valueEstimation?: string;
    projectType: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectListingId: "",
    projectName: "",
    projectAddress: "",
    projectId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [rabAdd, setRabAdd] = useState<{
    id: string;
    rabName: string;
    totalPrice: string;
    startDate: string;
    endDate: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    rabName: "",
    totalPrice: "",
    startDate: "",
    endDate: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [loadingVendors, setLoadingVendors] = useState(false);

  const [rabReviewDataAdd, setRabReviewDataAdd] = useState<RabDetail[]>([]);
  const [totalRabValueAdd, setTotalRabValueAdd] = useState(0);
  const [totalRabValueEdit, setTotalRabValueEdit] = useState(0);
  const [loadingRabReviewAdd, setLoadingRabReviewAdd] = useState(false);

  const resetAddForm = () => {
    setBiddingDataAdd({
      id: "",
      projectListingId: "",
      projectName: "",
      clientName: "",
      rabId: "",
      projectId: "",
      projectType: "",
      constructionPhase: "",
      rabName: "",
      bidAmount: 0,
      submissionDate: null,
      projectAddress: "",
      rabValue: 0,
      startDate: "",
      endDate: "",
      projectProcess: "",
      vendorNames: [""],
      vendorProjectValue: [""],
      status: "",
      biddingRegion: "",
      biddingCity: "",
      biddingDistrict: "",
      koefisien: 0,
      latitude: "",
      longitude: "",
      file: null,
    });
    setPreviewUrl("");
    setAdjustedRabReviewDataAdd([]);
  };

  const handleProjectChange = (e) => {
    const projectId = e.target.value; // This will be the project's id (not referenceId)
    const selectedProject = projectOptions.find(
      (proj) => proj.id === projectId
    );

    if (selectedProject) {
      setBiddingDataAdd((prev) => ({
        ...prev,
        projectId: selectedProject.projectReferenceId, // Map to projectReferenceId
        projectListingId: selectedProject.id, // Store actual id if needed
        projectName: selectedProject.projectName,
        clientName: selectedProject.source,
        projectType: selectedProject.projectType,
        constructionPhase: selectedProject.constructionPhase,
        projectAddress: selectedProject.projectAddress,
        latitude: selectedProject.latitude,
        longitude: selectedProject.longitude,
        biddingRegion: selectedProject.region,
        biddingCity: selectedProject.city,
        biddingDistrict: selectedProject.district,
      }));
    } else {
      // Reset all fields if no project selected
      setBiddingDataAdd((prev) => ({
        ...prev,
        projectId: "",
        projectListingId: "",
        projectName: "",
        clientName: "",
        projectType: "",
        constructionPhase: "",
        projectAddress: "",
        latitude: "",
        longitude: "",
        biddingRegion: "",
        biddingCity: "",
        biddingDistrict: "",
      }));
    }
  };

  const handleRabChangeAdd = async (rabId: string) => {
    if (!rabId) {
      setRabReviewDataAdd([]);
      setAdjustedRabReviewDataAdd([]);
      setSelectedRabItemsAdd([]);
      setTotalRabValueAdd(0);
      return;
    }

    setLoadingRabReviewAdd(true);
    try {
      const result = await getRabDetailsByRabId(rabId);

      // Map data dengan informasi AHS
      const rabDetailsWithAHS = result.data.map((detail): RabDetail => {
        const ahsDetail = ahsOptions.find((ahs) => ahs.id === detail.ahsId);

        // PERBAIKAN: Gunakan harga dasar AHS (totalJumlahHargaABC) jika tersedia
        const hargaDasarAHS = ahsDetail?.totalJumlahHargaABC
          ? parseFloat(ahsDetail.totalJumlahHargaABC)
          : parseFloat(detail.ahs?.hargaSatuan || "0") /
            (1 + (parseFloat(detail.ahs?.overheadKoefisien || "0.1")));

        const overheadKoefisien = parseFloat(detail.ahs?.overheadKoefisien || "0.1");
        const volume = parseFloat(detail.volume || "0");

        const hargaDenganOverhead = hargaDasarAHS * (1 + overheadKoefisien);
        const totalDenganOverhead = hargaDenganOverhead * volume;

        return {
          ...detail,
          category: ahsDetail?.category || detail.category || "",
          hargaSatuan: hargaDenganOverhead, // Unit Price dengan overhead default
          satuanAHS: ahsDetail?.satuanAHS || detail.satuanAHS || "",
          namaAHS: ahsDetail?.namaAHS || detail.namaAHS || "",
          totalHarga: totalDenganOverhead,
          volume: volume,
          overheadKoefisien: overheadKoefisien,
        };
      });

      setRabReviewDataAdd(rabDetailsWithAHS);
      setAdjustedRabReviewDataAdd(rabDetailsWithAHS); // Set data adjusted juga

      // Set koefisien default dari overheadKoefisien item pertama
      if (rabDetailsWithAHS.length > 0) {
        setBiddingDataAdd((prev) => ({
          ...prev,
          koefisien: rabDetailsWithAHS[0].overheadKoefisien,
        }));
      }

      // Hitung total awal
      const total = rabDetailsWithAHS.reduce(
        (acc, curr) => acc + (curr.totalHarga || 0),
        0
      );
      setTotalRabValueAdd(total);
    } catch (error) {
      console.error("Failed to fetch RAB review:", error);
      setRabReviewDataAdd([]);
      setAdjustedRabReviewDataAdd([]);
      setTotalRabValueAdd(0);
    } finally {
      setLoadingRabReviewAdd(false);
    }
  };

  const handleFileUpload = async (file) => {
    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate file type
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid file type",
        text: "Only PDF, EXCEL, WORD files are allowed",
      });
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "Maximum file size is 5MB",
      });
      return;
    }

    try {
      // For PDFs we can't create a preview URL like with images
      // Instead we'll just show the PDF icon and filename
      setPreviewUrl("file_uploaded"); // Just a flag to show uploaded state
      setBiddingDataAdd((prev) => ({ ...prev, file }));

      // If you want to upload immediately:
      if (biddingDataAdd.id) {
        await uploadProposal(biddingDataAdd.id, file);
        Swal.fire({
          icon: "success",
          title: "Proposal uploaded successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("Error uploading proposal:", error);
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: error.response?.data?.message || "Failed to upload proposal",
      });
      setPreviewUrl("");
      setBiddingDataAdd((prev) => ({ ...prev, file: null }));
    }
  };

  const handleOpenAddDialog = () => {
    resetAddForm();
    setOpenAddBiddingDialog(true);
  };

  const updateRabDataWithCoefficientAdd = (coefficients: {
    [key: string]: number;
  }) => {
    if (!rabReviewDataAdd.length) return;

    const adjustedData = rabReviewDataAdd.map((item) => {
      const itemId = item.id || "";
      const isSelected = selectedRabItemsAdd.includes(itemId);

      // Tentukan koefisien yang akan digunakan untuk perhitungan
      const itemCoefficient =
        isSelected && coefficients[itemId] !== undefined
          ? coefficients[itemId]
          : item.overheadKoefisien || 0.1;

      // Hitung harga dasar (sebelum overhead)
      const baseHargaSatuan =
        typeof item.hargaSatuan === "number"
          ? item.hargaSatuan / (1 + (item.overheadKoefisien || 0.1))
          : parseFloat(item.hargaSatuan || "0") /
            (1 + (item.overheadKoefisien || 0.1));

      const baseVolume =
        typeof item.volume === "number"
          ? item.volume
          : parseFloat(item.volume || "0");

      // Apply koefisien yang sesuai
      const adjustedHargaSatuan = baseHargaSatuan * (1 + itemCoefficient);
      const adjustedTotalHarga = adjustedHargaSatuan * baseVolume;

      return {
        ...item,
        hargaSatuan: adjustedHargaSatuan,
        totalHarga: adjustedTotalHarga,
        customCoefficient: itemCoefficient,
        isSelected: isSelected,
        hasCustomCoefficient: isSelected && coefficients[itemId] !== undefined,
      };
    });

    setAdjustedRabReviewDataAdd(adjustedData);

    // Hitung total baru
    const newTotal = adjustedData.reduce(
      (acc, curr) => acc + (curr.totalHarga || 0),
      0
    );
    setTotalRabValueAdd(newTotal);
  };

  const resetToOriginalPrices = () => {
    const originalData = rabReviewDataAdd.map((item) => {
      const baseHargaSatuan =
            item.ahs && item.ahs.totalJumlahHargaABC
              ? parseFloat(item.ahs.totalJumlahHargaABC)
              : parseFloat(item.hargaSatuan || "0");

      const baseVolume = parseFloat(item.volume || "0");
      const baseKoefisien = item.overheadKoefisien || 0.1;

      return {
        ...item,
        hargaSatuan: baseHargaSatuan * (1 + baseKoefisien),
        totalHarga: baseHargaSatuan * (1 + baseKoefisien) * baseVolume,
      };
    });

    setAdjustedRabReviewDataAdd(originalData);
    setTotalRabValueAdd(
      originalData.reduce((acc, curr) => acc + (curr.totalHarga || 0), 0)
    );
  };

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;

    setBiddingDataAdd((prev) => {
      const newData = { ...prev, [name]: value };

      // Jika koefisien berubah
      if (name === "koefisien") {
        const koefisienValue = parseFloat(value) || 0;

        // PERBAIKAN: Validasi range koefisien
        if (koefisienValue < 0 || koefisienValue > 10) {
          Swal.fire({
            icon: "warning",
            title: "Nilai tidak valid",
            text: "Koefisien harus antara 0 dan 10",
          });
          return prev; // Kembalikan nilai sebelumnya
        }

        // PERBAIKAN: Gunakan setTimeout untuk memastikan state koefisien sudah terupdate
        setTimeout(() => {
          if (selectedRabItemsAdd.length > 0) {
            updateRabDataWithCoefficientAdd(koefisienValue);
          } else {
            // Jika tidak ada yang dipilih, kembalikan ke harga asli
            const resetData = rabReviewDataAdd.map((item) => {
              const baseHargaSatuan =
                item.ahs && item.ahs.totalJumlahHargaABC
                  ? parseFloat(item.ahs.totalJumlahHargaABC)
                  : parseFloat(item.hargaSatuan || "0");

              const baseVolume = parseFloat(item.volume || "0");
              const baseKoefisien = item.overheadKoefisien || 0.1;

              return {
                ...item,
                hargaSatuan: baseHargaSatuan * (1 + baseKoefisien),
                totalHarga: baseHargaSatuan * (1 + baseKoefisien) * baseVolume,
              };
            });

            setAdjustedRabReviewDataAdd(resetData);
            setTotalRabValueAdd(
              resetData.reduce((acc, curr) => acc + (curr.totalHarga || 0), 0)
            );
          }
        }, 0);
      }

      return newData;
    });
  };

  const [errorsAdd, setErrorsAdd] = useState({
    projectName: false,
    rabName: false,
    submissionDate: false,
    projectProcess: false,
    vendorNames: false,
    vendorProjectValue: false,
    status: false,
  });

  const validateFormAdd = () => {
    let newErrors = {
      projectName: !biddingDataAdd.projectName,
      rabName: !biddingDataAdd.rabName,
      submissionDate: !biddingDataAdd.submissionDate,
      projectProcess: !biddingDataAdd.projectProcess,
      vendorNames: !biddingDataAdd.vendorNames,
      vendorProjectValue: !biddingDataAdd.vendorProjectValue,
      status: !biddingDataAdd.status,
    };
    setErrorsAdd(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleVendorChangeAdd = (index: number, vendorId: string) => {
    setBiddingDataAdd((prev) => {
      const newVendorNames = [...prev.vendorNames];
      newVendorNames[index] = vendorId;

      // Ensure vendorProjectValue array exists and has same length
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : new Array(prev.vendorNames.length).fill("");

      return {
        ...prev,
        vendorNames: newVendorNames,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  const handleProjectValueChangeAdd = (index: number, value: string) => {
    setBiddingDataAdd((prev) => {
      // Handle baik untuk array maupun nilai tunggal
      const newValues = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
        ? [prev.vendorProjectValue]
        : [""];

      newValues[index] = value;

      return {
        ...prev,
        vendorProjectValue: newValues,
      };
    });
  };

  const addVendorField = () => {
    setBiddingDataAdd((prev) => {
      // Pastikan vendorProjectValue adalah array
      const currentValues = Array.isArray(prev.vendorProjectValue)
        ? prev.vendorProjectValue
        : [prev.vendorProjectValue || ""];

      return {
        ...prev,
        vendorNames: [...prev.vendorNames, ""],
        vendorProjectValue: [...currentValues, ""], // Tambahkan string kosong untuk field baru
      };
    });
  };

  const removeVendorField = (index: number) => {
    setBiddingDataAdd((prev) => {
      // Filter out the item at the specified index
      const newVendorNames = prev.vendorNames.filter((_, i) => i !== index);
      const newVendorValues = prev.vendorProjectValue.filter(
        (_, i) => i !== index
      );

      return {
        ...prev,
        vendorNames: newVendorNames,
        vendorProjectValue: newVendorValues,
      };
    });
  };

  const handleSaveAdd = async () => {
    try {
      // Filter out empty vendor selections and ensure both arrays are aligned
      const validVendorEntries = biddingDataAdd.vendorNames
        .map((vendorId, index) => ({
          vendorId,
          projectValue: biddingDataAdd.vendorProjectValue[index],
        }))
        .filter((entry) => entry.vendorId && entry.projectValue);

      if (validVendorEntries.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Vendor Required",
          text: "Please select at least one vendor with project value",
          confirmButtonColor: "#0F62FE",
        });
        return;
      }

      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }

      // Prepare the payload with aligned vendor data
      const payload = {
        ...biddingDataAdd,
        vendorNames: validVendorEntries.map((entry) => entry.vendorId),
        vendorProjectValue: validVendorEntries.map(
          (entry) => entry.projectValue
        ),
      };

      // Step 1: Create bidding
      const response = await createBidding(payload);

      // Step 2: Upload proposal file if available
      if (biddingDataAdd.file) {
        await uploadProposal(response.id, biddingDataAdd.file);
      }

      // Step 3: Create bidding adjustments untuk SEMUA ITEM dalam RAB review
      if (rabReviewDataAdd.length > 0) {
        const adjustments: BiddingAdjustmentData[] = [];

        // Loop melalui SEMUA ITEM dalam RAB review (bukan hanya yang dipilih)
        for (const item of rabReviewDataAdd) {
          const itemId = item.id || "";
          const isSelected = selectedRabItemsAdd.includes(itemId);

          // Tentukan koefisien yang akan disimpan:
          // - Jika item dipilih DAN ada koefisien custom: gunakan custom
          // - Selain itu: gunakan koefisien default dari AHS
          const koefisien =
            isSelected && itemCoefficientsAdd[itemId] !== undefined
              ? itemCoefficientsAdd[itemId]
              : item.overheadKoefisien || 0.1;

          // PERBAIKAN: Hitung harga dasar (tanpa overhead) secara konsisten
          const currentHargaSatuan = typeof item.hargaSatuan === "number"
            ? item.hargaSatuan
            : parseFloat(item.hargaSatuan || "0");
          
          const currentOverhead = item.overheadKoefisien || 0.1;

          const baseHargaSatuan = currentHargaSatuan / (1 + currentOverhead);

          const baseVolume =
            typeof item.volume === "number"
              ? item.volume
              : parseFloat(item.volume || "0");

          // Hitung total harga dengan koefisien yang sesuai
          const adjustedHargaSatuan = baseHargaSatuan * (1 + koefisien);
          const totalHarga = adjustedHargaSatuan * baseVolume;

          adjustments.push({
            biddingId: response.id,
            rabId: biddingDataAdd.rabId,
            rabDetailId: itemId,
            ahsId: item.ahsId || "",
            koefisien: koefisien, // koefisien is number
            totalHarga: totalHarga,
            isCustom: isSelected && itemCoefficientsAdd[itemId] !== undefined,
          });
        }

        // Create adjustments untuk semua item
        if (adjustments.length > 0) {
          await createBiddingAdjustments(adjustments);
        }
      }

      Swal.fire({
        icon: "success",
        title: "Bidding berhasil ditambahkan",
        confirmButtonColor: "#0F62FE",
      });

      setOpenAddBiddingDialog(false);
      reloadBidding();
      resetAddForm();
    } catch (error: any) {
      let errorTitle = "Gagal membuat bidding";
      let errorDetails = "";

      // Handle backend error response
      if (error.response?.data) {
        const backendError = error.response.data;

        console.log(
          "Backend Error Structure:",
          JSON.stringify(backendError, null, 2)
        );

        errorTitle = backendError.error || errorTitle;

        const isEmailValidationError =
          (backendError.details &&
            /validation isEmail on (email|biddingEmail)/i.test(
              backendError.details
            )) ||
          (backendError.errors &&
            backendError.errors.some(
              (err: any) =>
                (err.path === "email" || err.path === "biddingEmail") &&
                err.validatorKey === "isEmail"
            )) ||
          (backendError.message &&
            /email.*invalid/i.test(backendError.message));

        if (isEmailValidationError) {
          errorTitle = "Format Email Tidak Valid";
          errorDetails =
            "• Format email tidak valid (contoh: nama@perusahaan.com)";
        } else if (backendError.details) {
          errorDetails = backendError.details;
        }

        if (backendError.errors) {
          const validationMessages = backendError.errors
            .map((err: any) => {
              const errorObj = Array.isArray(err) ? err[0] : err;
              if (
                (errorObj.path === "email" ||
                  errorObj.path === "biddingEmail") &&
                errorObj.validatorKey === "isEmail"
              ) {
                return null;
              }
              return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
            })
            .filter(Boolean)
            .join("\n");

          if (validationMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${validationMessages}`
              : validationMessages;
          }
        }

        if (backendError.duplicates) {
          const duplicateMessages = backendError.duplicates
            .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
            .join("\n");

          if (duplicateMessages) {
            errorDetails = errorDetails
              ? `${errorDetails}\n${duplicateMessages}`
              : duplicateMessages;
          }
        }
      } else {
        errorDetails =
          error.message || "Terjadi kesalahan jaringan atau server";
      }

      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
              ${errorTitle}
            </p>
            ${
              errorDetails
                ? `<div style="
                    color: #5f2120;
                    background: #fdecea;
                    padding: 12px;
                    border-radius: 4px;
                    font-size: 0.9em;
                    border-left: 4px solid #d32f2f;
                    line-height: 1.5;
                  ">
                    ${errorDetails.replace(/\n/g, "<br>")}
                  </div>`
                : ""
            }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
        width: "600px",
      });
    }
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [editVendorProposalUrlPreview, setEditVendorProposalUrlPreview] =
    useState<string>("");
  const [editProposalUrlFile, setEditProposalUrlFile] = useState<File | null>(
    null
  );

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleCloseAdd = () => {
    setOpenAddBiddingDialog(false);
    resetAddForm();
    // Reset RAB review data juga
    setSelectedRabItemsAdd([]);
    setRabReviewDataAdd([]);
    setTotalRabValueAdd(0);
    // Reset koefisien ke default
    setBiddingDataAdd((prev) => ({ ...prev, koefisien: 0 }));
  };

  useEffect(() => {
    const loadVendors = async () => {
      setLoadingVendors(true);
      try {
        const vendorsData = await fetchVendors();
        setVendors(vendorsData);
      } catch (error) {
        console.error("Gagal memuat vendors:", error);
      } finally {
        setLoadingVendors(false);
      }
    };

    loadVendors();
  }, []);

  useEffect(() => {
    if (rabReviewDataAdd.length) {
      setAdjustedRabReviewDataAdd(rabReviewDataAdd);
    }
  }, [rabReviewDataAdd]);

  useEffect(() => {
    if (rabReviewDataEdit.length) {
      setAdjustedRabReviewDataEdit(rabReviewDataEdit);
    }
  }, [rabReviewDataEdit]);

  //edit bidding data ========================================================================
  const [isEditing, setIsEditing] = useState(false);

  const [selectedBiddingId, setSelectedBiddingId] = useState<number | null>(
    null
  );
  const [biddingDataEdit, setBiddingDataEdit] = useState<{
    id: string;
    projectListingId: string;
    projectName: string;
    clientName: string;
    rabId: string;
    projectId: string;
    projectType: string;
    constructionPhase: string;
    rabName: string;
    bidAmount: number;
    submissionDate: Date | null;
    projectAddress: string;
    rabValue: number;
    startDate: string;
    endDate: string;
    projectProcess: string;
    vendorNames: any[];
    vendorProjectValue: any[];
    status: string;
    biddingAddress: string;
    biddingRegion: string;
    biddingCity: string;
    biddingDistrict: string;
    koefisien: number;
    latitude: string;
    longitude: string;
    file: File | null;
    previewUrl: string; // Add this
    vendorProposalUrl: string;
  }>({
    id: "",
    projectListingId: "",
    projectName: "",
    clientName: "",
    rabId: "",
    projectId: "",
    projectType: "",
    constructionPhase: "",
    rabName: "",
    bidAmount: 0,
    submissionDate: null,
    projectAddress: "",
    rabValue: 0,
    startDate: "",
    endDate: "",
    projectProcess: "",
    vendorNames: [""],
    vendorProjectValue: [""],
    status: "",
    biddingAddress: "",
    biddingRegion: "",
    biddingCity: "",
    biddingDistrict: "",
    koefisien: 0,
    latitude: "",
    longitude: "",
    file: null,
    previewUrl: "", // Add this
    vendorProposalUrl: "",
  });

  const [ahsOptions, setAhsOptions] = useState<any[]>([]);

  const fetchAhsList = async () => {
    try {
      const result = await fetchAhs();
      setAhsOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchBiddingAdjustments = async () => {
    setLoadingAdjustments(true);
    try {
      const adjustmentsData = await viewBiddingAdjustment();

      // Pastikan kita selalu mendapatkan array
      const adjustmentsArray = Array.isArray(adjustmentsData)
        ? adjustmentsData
        : adjustmentsData.data || [];

      setBiddingAdjustments(adjustmentsArray);
    } catch (error: any) {
      console.error("Failed to fetch bidding adjustments:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load bidding adjustments",
        text: error.response?.data?.message || error.message || "Please try again later",
      });
    } finally {
      setLoadingAdjustments(false);
    }
  };

  // Tambahkan tipe untuk fungsi helper
  // Fungsi helper untuk generate nama file yang konsisten antara UI dan download
  const generateDisplayFilename = (projectName: string): string => {
    if (!projectName) return "Bidding_unknown_project.pdf";

    // Cari project yang sesuai
    const selectedProject = projectOptions.find(
      (opt) => opt.projectName === projectName || opt.id === projectName
    );

    const actualProjectName = selectedProject?.projectName || projectName;

    // Bersihkan nama project untuk nama file
    const cleanProjectName = actualProjectName
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "")
      .substring(0, 50);

    return `Bidding_${cleanProjectName}.pdf`;
  };

  const handleDownload = async (filename: string) => {
    try {
      const { blob } = await getProposalFile(filename);

      // Generate datetime string format: YYYYMMDD_HHMMSS
      const now = new Date();
      const datetime = now
        .toISOString()
        .replace(/[:.-]/g, "") // Remove colons, dots, and dashes
        .replace("T", "_") // Replace T with underscore
        .slice(0, 15); // Take YYYYMMDD_HHMMSS (15 characters)

      // Generate base filename tanpa extension
      const baseFilename = generateDisplayFilename(biddingDataEdit.projectName);

      // Hapus extension .pdf jika ada
      const filenameWithoutExt = baseFilename.endsWith(".pdf")
        ? baseFilename.slice(0, -4)
        : baseFilename;

      // Tambahkan datetime dan pastikan extension .pdf
      const downloadFilename = `${filenameWithoutExt}_${datetime}.pdf`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = downloadFilename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error instanceof Error ? error.message : "Failed to download file",
      });
    }
  };

  const exportRabDetailToPDFBidding = async () => {
    try {
      const doc = new jsPDF();

      // 1. Add header image
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", -10, 0, 230, 40);
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      // Add horizontal line after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 37, 200, 37);

      // 2. Main content
      const startY = 60;
      doc.setFontSize(18);
      const titleText = `RAB Review: ${biddingDataEdit.rabName || "-"}`;
      const wrappedTitle = doc.splitTextToSize(titleText, 170);
      doc.text(wrappedTitle, 105, startY - 15, { align: "center" });

      // ===== PROJECT INFORMATION TABLE =====
      doc.setFontSize(12);
      doc.text("Project Information", 15, startY + 2);

      const project =
        projectOptions.find(
          (pro) => pro.id === biddingDataEdit.projectListingId
        ) || {};

      autoTable(doc, {
        head: [["Name", "Description"]],
        body: [
          ["Project Name", project.projectName || "-"],
          ["Project Code", project.projectReferenceId || "-"],
          ["Project Type", project.projectType || "-"],
          [
            "Value Estimation",
            `Rp ${Number(project.valueEstimation || 0).toLocaleString(
              "id-ID"
            )}`,
          ],
          ["Project Address", project.projectAddress || "-"],
          ["Source", project.source || "-"],
          ["Construction Phase", project.constructionPhase || "-"],
          ["Start Date", project.startDate || "-"],
          ["End Date", project.endDate || "-"],
          ["Latitude", project.latitude || "-"],
          ["Longitude", project.longitude || "-"],
        ],
        startY: startY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 3,
          fontSize: 8,
        },
        columnStyles: {
          0: { cellWidth: 60, fontStyle: "bold" },
          1: { cellWidth: 120 },
        },
        didDrawPage: function (data) {
          // Page number untuk halaman pertama
          doc.setFontSize(8);
          doc.text(
            `Page 1`,
            data.settings.margin.left,
            doc.internal.pageSize.height - 10
          );
        },
      });

      // ===== RAB REVIEW TABLE =====
      const rabStartY = (doc as any).lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.text("RAB Review Details", 15, rabStartY);

      // HITUNG ULANG TOTAL DARI DATA ADJUSTMENT
      const calculatedTotal = adjustedRabReviewDataEdit.reduce((acc, item) => {
        const itemTotal =
          adjustmentTotalPrices[item.id || ""] !== undefined
            ? adjustmentTotalPrices[item.id || ""]
            : typeof item.totalHarga === "number"
            ? item.totalHarga
            : parseFloat(item.totalHarga || "0");
        return acc + itemTotal;
      }, 0);

      const ppn = calculatedTotal * 0.11;
      const totalWithPPN = calculatedTotal + ppn;

      // BAGI DATA MENJADI BEBERAPA HALAMAN TANPA FOOTER
      let currentData = adjustedRabReviewDataEdit;
      let currentStartY = rabStartY + 5;
      const rowsPerPage = 20; // Jumlah maksimal baris per halaman
      let currentPage = 1; // Mulai dari halaman 1 (karena project info di halaman 1)
      const totalPages =
        Math.ceil(adjustedRabReviewDataEdit.length / rowsPerPage) + 1; // +1 untuk halaman project info

      while (currentData.length > 0) {
        currentPage++; // Increment page untuk setiap halaman RAB review
        const pageData = currentData.slice(0, rowsPerPage);
        currentData = currentData.slice(rowsPerPage);

        const tableBody = pageData.map((item, i) => {
          const totalPrice =
            adjustmentTotalPrices[item.id || ""] !== undefined
              ? adjustmentTotalPrices[item.id || ""]
              : typeof item.totalHarga === "number"
              ? item.totalHarga
              : parseFloat(item.totalHarga || "0");

          const unitPrice =
            adjustmentUnitPrices[item.id || ""] !== undefined
              ? adjustmentUnitPrices[item.id || ""]
              : typeof item.hargaSatuan === "number"
              ? item.hargaSatuan
              : parseFloat(item.hargaSatuan || "0");

          const globalIndex = (currentPage - 2) * rowsPerPage + i; // -2 karena halaman 1 adalah project info

          return [
            `${globalIndex + 1}`,
            item.category || "-",
            item.namaAHS || "-",
            item.volume || "-",
            item.satuanAHS || "-",
            {
              content:
                `Rp ${Math.round(unitPrice).toLocaleString("id-ID")}` || "-",
              styles: { halign: "right" },
            },
            {
              content:
                `Rp ${Math.round(totalPrice).toLocaleString("id-ID")}` || "-",
              styles: { halign: "right" },
            },
          ];
        });

        autoTable(doc, {
          head: [
            [
              "No",
              "Category",
              "Description",
              "Volume",
              "Unit",
              "Unit Price",
              "Total Price",
            ],
          ],
          body: tableBody,
          startY: currentStartY,
          margin: { left: 15 },
          headStyles: {
            fillColor: [100, 100, 100],
            textColor: 255,
            fontStyle: "bold",
          },
          styles: {
            cellPadding: 2,
            fontSize: 8,
          },
          columnStyles: {
            4: { cellWidth: "auto", minCellHeight: 10 },
          },
          // TIDAK PAKAI FOOTER DI SINI
          foot: [],
          didDrawPage: function (data) {
            // Page number untuk halaman RAB review
            doc.setFontSize(8);
            doc.text(
              `Page ${currentPage} of ${totalPages}`,
              data.settings.margin.left,
              doc.internal.pageSize.height - 10
            );
          },
        });

        // Jika masih ada data, buat halaman baru
        if (currentData.length > 0) {
          doc.addPage();
          currentStartY = 20; // Reset Y position untuk halaman baru
          currentPage++; // Increment untuk halaman baru

          // Tambahkan header untuk halaman berikutnya
          doc.setFontSize(12);
          doc.text("RAB Review Details (Continued)", 15, 15);
        }
      }

      // ===== BUAT HALAMAN TERAKHIR UNTUK SUMMARY =====
      const lastTableBottom = (doc as any).lastAutoTable.finalY;

      // Cek jika masih ada space di halaman terakhir, jika tidak buat halaman baru
      let summaryY = lastTableBottom + 10;
      let needsNewPage = summaryY > doc.internal.pageSize.height - 50;

      if (needsNewPage) {
        doc.addPage();
        summaryY = 20;
        currentPage++; // Increment untuk halaman summary
      }

      // BUAT SUMMARY TABLE MANUAL (HANYA DI HALAMAN TERAKHIR)
      autoTable(doc, {
        body: [
          [
            {
              content: "Jumlah",
              colSpan: 6,
              styles: {
                halign: "right",
                fontStyle: "bold",
                fillColor: [240, 240, 240],
              },
            },
            {
              content: `Rp ${Math.round(calculatedTotal).toLocaleString(
                "id-ID"
              )}`,
              styles: {
                halign: "right",
                fontStyle: "bold",
                fillColor: [240, 240, 240],
              },
            },
          ],
          [
            {
              content: "PPN 11%",
              colSpan: 6,
              styles: {
                halign: "right",
                fillColor: [245, 245, 245],
              },
            },
            {
              content: `Rp ${Math.round(ppn).toLocaleString("id-ID")}`,
              styles: {
                halign: "right",
                fillColor: [245, 245, 245],
              },
            },
          ],
          [
            {
              content: "Total + PPN",
              colSpan: 6,
              styles: {
                halign: "right",
                fontStyle: "bold",
                fillColor: [230, 230, 230],
              },
            },
            {
              content: `Rp ${Math.round(totalWithPPN).toLocaleString("id-ID")}`,
              styles: {
                halign: "right",
                fontStyle: "bold",
                fillColor: [230, 230, 230],
              },
            },
          ],
        ],
        startY: summaryY,
        margin: { left: 15 },
        styles: {
          cellPadding: 3,
          fontSize: 9,
          textColor: [0, 0, 0],
        },
        columnStyles: {
          6: { cellWidth: 30 },
        },
        tableLineWidth: 0.1,
        tableLineColor: [0, 0, 0],
        didDrawPage: function (data) {
          // Update page number untuk halaman summary
          if (needsNewPage) {
            doc.setFontSize(8);
            doc.text(
              `Page ${currentPage} of ${totalPages}`,
              data.settings.margin.left,
              doc.internal.pageSize.height - 10
            );
          }
        },
      });

      // ===== AMOUNT IN WORDS =====
      const summaryTableBottom = (doc as any).lastAutoTable.finalY;
      let amountY = summaryTableBottom + 15;

      doc.setFontSize(9);
      const amountText = `Terbilang: ${terbilang(
        Math.round(totalWithPPN)
      )} Rupiah`;
      const splitAmountText = doc.splitTextToSize(amountText, 180);
      doc.text(splitAmountText, 15, amountY);

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(
        `RAB_Review_${biddingDataEdit.rabName || "bidding"}_${date}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportRabDetailToExcelBidding = async () => {
    try {
      // Prepare data for Excel export
      const project =
        projectOptions.find(
          (pro) => pro.id === biddingDataEdit.projectListingId
        ) || {};

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create Project Information sheet
      const projectInfoData = [
        ["RAB Review Name", biddingDataEdit.rabName || "-"],
        ["Project Name", project.projectName || "-"],
        ["Project Code", project.projectReferenceId || "-"],
        ["Project Type", project.projectType || "-"],
        ["Value Estimation", `${Number(project.valueEstimation || 0)}`],
        ["Project Address", project.projectAddress || "-"],
        ["Source", project.source || "-"],
        ["Construction Phase", project.constructionPhase || "-"],
        ["Start Date", project.startDate || "-"],
        ["End Date", project.endDate || "-"],
        ["Latitude", project.latitude || "-"],
        ["Longitude", project.longitude || "-"],
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet([
        ["PROJECT INFORMATION"],
        [], // empty row
        ...projectInfoData,
      ]);

      // 3. Create RAB Review Details sheet
      const rabReviewHeader = [
        "No",
        "Category",
        "Description",
        "Volume",
        "Unit",
        "Unit Price",
        "Total Price",
      ];

      const rabReviewData = adjustedRabReviewDataEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        item.volume || "-",
        item.satuanAHS || "-",
        `${Math.round(Number(item.hargaSatuan))}`,
        `${Math.round(Number(item.totalHarga))}`,
      ]);

      // HITUNG ULANG TOTAL DARI DATA ADJUSTMENT
      const calculatedTotal = adjustedRabReviewDataEdit.reduce((acc, item) => {
        const itemTotal =
          adjustmentTotalPrices[item.id || ""] !== undefined
            ? adjustmentTotalPrices[item.id || ""]
            : typeof item.totalHarga === "number"
            ? item.totalHarga
            : parseFloat(item.totalHarga || "0");
        return acc + itemTotal;
      }, 0);

      const ppn = calculatedTotal * 0.11;
      const totalWithPPN = calculatedTotal + ppn;

      const rabReviewWs = XLSX.utils.aoa_to_sheet([
        ["RAB REVIEW DETAILS"],
        [], // empty row
        rabReviewHeader,
        ...rabReviewData,
        [], // empty row
        ["Subtotal:", "", "", "", "", "", `${calculatedTotal}`],
        ["Tax (11%):", "", "", "", "", "", `${Math.round(ppn)}`],
        ["Total + PPN:", "", "", "", "", "", `${Math.round(totalWithPPN)}`],
        [], // empty row
        ["Amount in words:", terbilang(Math.round(totalWithPPN)) + " Rupiah"],
      ]);

      // 4. Formatting and styling
      // Project Info sheet formatting
      projectInfoWs["!cols"] = [
        { wch: 20 }, // Column A width
        { wch: 40 }, // Column B width
      ];

      // RAB Review sheet formatting
      rabReviewWs["!cols"] = [
        { wch: 5 }, // No
        { wch: 25 }, // Category
        { wch: 35 }, // Description
        { wch: 10 }, // Volume
        { wch: 10 }, // Unit
        { wch: 15 }, // Unit Price
        { wch: 15 }, // Total Price
      ];

      // Merge title cells
      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // Merge PROJECT INFORMATION title
      ];

      rabReviewWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge RAB REVIEW DETAILS title
        {
          s: { r: rabReviewData.length + 3, c: 0 },
          e: { r: rabReviewData.length + 3, c: 6 },
        }, // Merge amount in words
        {
          s: { r: rabReviewData.length + 4, c: 0 },
          e: { r: rabReviewData.length + 4, c: 6 },
        }, // Merge amount in words value
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, rabReviewWs, "RAB Review");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(
        wb,
        `RAB_Review_${biddingDataEdit.rabName || "bidding"}_${date}.xlsx`
      );
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  const handleOpenEditDialog = async (bidding) => {
    try {
      let previewUrl;
      let fileObject;

      console.log("bidding", bidding);

      // Handle the proposal file if it exists
      if (bidding.vendorProposalUrl) {
        try {
          const { blob } = await getProposalFile(bidding.vendorProposalUrl);
          const fileType = blob.type;

          if (fileType.startsWith("image/")) {
            previewUrl = URL.createObjectURL(blob);
          } else {
            previewUrl = "file_uploaded";
          }

          fileObject = new File([blob], bidding.vendorProposalUrl, {
            type: fileType,
          });
        } catch (error) {
          console.warn("Failed to load proposal file:", error);
          previewUrl = "file_uploaded";
        }
      }

      // Find matching project and RAB
      const matchedProject = projectOptions.find(
        (project) => project.id === bidding.projectName
      );
      const matchedRab = rabOptions.find((rab) => rab.id === bidding.rabName);

      // Normalize vendor data to arrays
      const vendorNames = Array.isArray(bidding.vendorNames)
        ? bidding.vendorNames
        : bidding.vendorNames
        ? [bidding.vendorNames]
        : [];

      const vendorProjectValue = Array.isArray(bidding.vendorProjectValue)
        ? bidding.vendorProjectValue
        : bidding.vendorProjectValue
        ? [bidding.vendorProjectValue]
        : new Array(vendorNames.length).fill("");

      // Ensure arrays have same length
      const normalizedVendorProjectValue =
        vendorProjectValue.length >= vendorNames.length
          ? vendorProjectValue.slice(0, vendorNames.length)
          : [
              ...vendorProjectValue,
              ...new Array(vendorNames.length - vendorProjectValue.length).fill(
                ""
              ),
            ];

      // Transform the bidding data
      const editData = {
        id: bidding.id,
        projectListingId: bidding.projectName,
        projectName: matchedProject?.projectName || bidding.projectName || "",
        clientName: matchedProject?.source || bidding.clientName || "",
        rabId: bidding.rabName,
        rabName: matchedRab?.rabName || bidding.rabName || "",
        bidAmount: bidding.bidAmmount,
        projectId: bidding.projectId,
        projectType: matchedProject?.projectType || bidding.projectType || "",
        constructionPhase: bidding.constructionPhase,
        submissionDate: bidding.submissionDate
          ? new Date(bidding.submissionDate)
          : null,
        projectAddress: matchedProject?.projectAddress,
        rabValue: bidding.rabValue,
        startDate: bidding.startDate,
        endDate: bidding.endDate,
        projectProcess: bidding.projectProcess,
        vendorNames: vendorNames,
        vendorProjectValue: normalizedVendorProjectValue,
        status: bidding.status,
        biddingRegion: matchedProject?.region,
        biddingCity: matchedProject?.city,
        biddingDistrict: matchedProject?.district,
        latitude: matchedProject?.latitude,
        longitude: matchedProject?.longitude,
        file: fileObject,
        previewUrl: previewUrl,
        vendorProposalUrl: bidding.vendorProposalUrl,
      };

      console.log("edit data", editData);

      setBiddingDataEdit(editData);
      setOpenEditBiddingDialog(true);
      setIsEditing(false);

      // PERBAIKAN: Load RAB review data dan adjustments SEQUENTIALLY
      if (editData.rabId) {
        setLoadingRabReview(true);

        try {
          // Step 1: Load RAB details first
          const result = await getRabDetailsByRabId(editData.rabId);

          // Map data dengan informasi AHS
          const rabDetailsWithAHS = result.data.map((detail): RabDetail => {
            const ahsDetail = ahsOptions.find((ahs) => ahs.id === detail.ahsId);

            // PERBAIKAN: Gunakan logic yang sama dengan fetchRabReview dan handleRabChangeAdd
            const hargaDasarAHS = ahsDetail?.totalJumlahHargaABC
              ? parseFloat(ahsDetail.totalJumlahHargaABC)
              : parseFloat(detail.ahs?.hargaSatuan || "0") /
                (1 + (parseFloat(detail.ahs?.overheadKoefisien || "0.1")));

            const overheadKoefisien = parseFloat(detail.ahs?.overheadKoefisien || "0.1");
            const volume = parseFloat(detail.volume || "0");

            const hargaDenganOverhead = hargaDasarAHS * (1 + overheadKoefisien);
            const totalDenganOverhead = hargaDenganOverhead * volume;

            return {
              ...detail,
              category: ahsDetail?.category || detail.category || "",
              hargaSatuan: hargaDenganOverhead,
              satuanAHS: ahsDetail?.satuanAHS || detail.satuanAHS || "",
              namaAHS: ahsDetail?.namaAHS || detail.namaAHS || "",
              totalHarga: totalDenganOverhead,
              volume: volume,
              overheadKoefisien: overheadKoefisien,
            };
          });

          setRabReviewDataEdit(rabDetailsWithAHS);

          // Step 2: Load adjustments setelah RAB data ready
          await loadAdjustmentsForEdit(bidding.id, rabDetailsWithAHS);
        } catch (error) {
          console.error("Failed to fetch RAB review:", error);
          setRabReviewDataEdit([]);
          setAdjustedRabReviewDataEdit([]);
          setTotalRabValueEdit(0);
          setTotalRabValue(0);
        } finally {
          setLoadingRabReview(false);
        }
      } else {
        // Jika tidak ada rabId, reset values
        setRabReviewDataEdit([]);
        setAdjustedRabReviewDataEdit([]);
        setTotalRabValueEdit(0);
        setTotalRabValue(0);
      }
    } catch (error) {
      console.error("Failed to open edit dialog:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Load Bidding Data",
        text: error.message || "Could not load bidding data for editing",
      });
    }
  };

  // FUNGSI BARU: Load adjustments secara terpisah
  const loadAdjustmentsForEdit = async (
    biddingId: string,
    rabDetails: RabDetail[]
  ) => {
    try {
      // Gunakan fungsi yang sudah diperbaiki
      const existingAdjustments = await getBiddingAdjustmentsByBiddingId(
        biddingId
      );

      console.log("Existing adjustments for edit:", existingAdjustments.data);

      const selectedItems: string[] = [];
      const itemCoefficients: { [key: string]: number } = {};
      const adjustmentTotalPrices: { [key: string]: number } = {};
      const adjustmentUnitPrices: { [key: string]: number } = {};

      let calculatedTotalFromAdjustments = 0;

      // Process each adjustment - AMBIL DATA DARI API
      existingAdjustments.data.forEach((adjustment) => {
        if (adjustment.rabDetailId) {
          selectedItems.push(adjustment.rabDetailId);

          // PERBAIKAN: Convert string koefisien dari API ke number
          const koefisienValue = parseFloat(adjustment.koefisien);
          itemCoefficients[adjustment.rabDetailId] = isNaN(koefisienValue)
            ? 0.1
            : koefisienValue;

          // SIMPAN totalHarga dari adjustment (bukan dari RAB detail)
          const totalHargaValue = parseFloat(adjustment.totalHarga);
          adjustmentTotalPrices[adjustment.rabDetailId] = isNaN(totalHargaValue)
            ? 0
            : totalHargaValue;

          // TAMBAHKAN KE TOTAL
          calculatedTotalFromAdjustments +=
            adjustmentTotalPrices[adjustment.rabDetailId];

          // HITUNG UNIT PRICE DARI TOTAL HARGA DAN VOLUME
          const rabDetail = rabDetails.find(
            (rd) => rd.id === adjustment.rabDetailId
          );
          if (rabDetail) {
            const volume = parseFloat(rabDetail.volume || "1");
            adjustmentUnitPrices[adjustment.rabDetailId] =
              volume > 0 ? totalHargaValue / volume : totalHargaValue;
          }

          console.log("Adjustment data:", {
            rabDetailId: adjustment.rabDetailId,
            koefisien: adjustment.koefisien,
            parsedKoefisien: itemCoefficients[adjustment.rabDetailId],
            totalHarga: adjustment.totalHarga,
            parsedTotalHarga: adjustmentTotalPrices[adjustment.rabDetailId],
            unitPrice: adjustmentUnitPrices[adjustment.rabDetailId],
          });
        }
      });

      setSelectedRabItemsEdit(selectedItems);
      setItemCoefficientsEdit(itemCoefficients);
      setAdjustmentTotalPrices(adjustmentTotalPrices);
      setAdjustmentUnitPrices(adjustmentUnitPrices);

      // PERBAIKAN: Update data RAB review dengan nilai dari adjustments
      if (rabDetails.length > 0) {
        const adjustedData = rabDetails.map((item) => {
          const itemId = item.id || "";
          const isSelected = selectedItems.includes(itemId);

          // GUNAKAN DATA DARI ADJUSTMENT JIKA ADA
          const adjustmentCoefficient =
            itemCoefficients[itemId] !== undefined
              ? itemCoefficients[itemId]
              : item.overheadKoefisien || 0.1;

          const adjustmentTotalPrice =
            adjustmentTotalPrices[itemId] !== undefined
              ? adjustmentTotalPrices[itemId]
              : parseFloat(item.totalHarga || "0");

          const adjustmentUnitPrice =
            adjustmentUnitPrices[itemId] !== undefined
              ? adjustmentUnitPrices[itemId]
              : parseFloat(item.hargaSatuan || "0");

          // PERBAIKAN: Hitung harga dasar dari AHS (bukan dari adjusted price)
          const hargaDasarAHS = item.ahs?.totalJumlahHargaABC
            ? parseFloat(item.ahs.totalJumlahHargaABC)
            : item.ahs?.hargaSatuan ? parseFloat(item.ahs.hargaSatuan) : adjustmentUnitPrice / (1 + adjustmentCoefficient);

          const volume = parseFloat(item.volume || "1");

          return {
            ...item,
            hargaSatuan: adjustmentUnitPrice,
            totalHarga: adjustmentTotalPrice,
            baseHargaSatuan: hargaDasarAHS, // Simpan harga dasar AHS
            customCoefficient: adjustmentCoefficient,
            isSelected: isSelected,
            hasCustomCoefficient: itemCoefficients[itemId] !== undefined,
            volume: volume,
          };
        });

        setAdjustedRabReviewDataEdit(adjustedData);

        // PERBAIKAN: Gunakan calculatedTotalFromAdjustments yang sudah dihitung
        const finalTotal = Object.values(adjustmentTotalPrices).reduce(
          (acc, curr) => acc + curr,
          0
        );

        console.log("Final total from adjustments:", finalTotal);
        console.log("AdjustmentTotalPrices:", adjustmentTotalPrices);

        // PERBAIKAN: Update kedua state total dengan nilai yang sama
        setTotalRabValueEdit(finalTotal);
        setTotalRabValue(finalTotal);

        console.log("Adjusted data with API values:", adjustedData);
        console.log("Total RAB Value Edit:", finalTotal);
      }
    } catch (error) {
      console.warn("Failed to load existing adjustments:", error);
      // Fallback ke data original jika gagal load adjustments
      const fallbackData = rabDetails.map((item) => ({
        ...item,
        hargaSatuan: parseFloat(item.hargaSatuan || "0"),
        totalHarga: parseFloat(item.totalHarga || "0"),
        baseHargaSatuan:
          parseFloat(item.hargaSatuan || "0") /
          (1 + (item.overheadKoefisien || 0.1)),
      }));

      setAdjustedRabReviewDataEdit(fallbackData);

      const fallbackTotal = fallbackData.reduce(
        (acc, curr) => acc + (curr.totalHarga || 0),
        0
      );
      setTotalRabValueEdit(fallbackTotal);
      setTotalRabValue(fallbackTotal);
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Suspended":
        return "statusRed";
      case "Inactive":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const handleVendorChangeEdit = (index: number, vendorId: string) => {
    setBiddingDataEdit((prev) => {
      const newVendorNames = [...prev.vendorNames];
      newVendorNames[index] = vendorId;

      // Ensure vendorProjectValue is array with same length
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
        ? [prev.vendorProjectValue]
        : new Array(prev.vendorNames.length).fill("");

      return {
        ...prev,
        vendorNames: newVendorNames,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  // Handle project value change
  const handleProjectValueChangeEdit = (index: number, value: string) => {
    setBiddingDataEdit((prev) => {
      const newVendorProjectValue = Array.isArray(prev.vendorProjectValue)
        ? [...prev.vendorProjectValue]
        : prev.vendorProjectValue
        ? [prev.vendorProjectValue]
        : new Array(prev.vendorNames.length).fill("");

      newVendorProjectValue[index] = value;

      return {
        ...prev,
        vendorProjectValue: newVendorProjectValue,
      };
    });
  };

  // Add new vendor field
  const addVendorFieldEdit = () => {
    setBiddingDataEdit((prev) => ({
      ...prev,
      vendorNames: [...prev.vendorNames, ""],
      vendorProjectValue: [
        ...(Array.isArray(prev.vendorProjectValue)
          ? prev.vendorProjectValue
          : [prev.vendorProjectValue || ""]),
        "",
      ],
    }));
  };

  // Remove vendor field
  const removeVendorFieldEdit = (index: number) => {
    setBiddingDataEdit((prev) => ({
      ...prev,
      vendorNames: prev.vendorNames.filter((_, i) => i !== index),
      vendorProjectValue: (Array.isArray(prev.vendorProjectValue)
        ? prev.vendorProjectValue
        : [prev.vendorProjectValue || ""]
      ).filter((_, i) => i !== index),
    }));
  };

  const handleRabItemSelectAdd = (itemId: string, checked: boolean) => {
    let newSelectedItems: string[];
    let newCoefficients = { ...itemCoefficientsAdd };

    if (checked) {
      newSelectedItems = [...selectedRabItemsAdd, itemId];
      // Set koefisien default untuk item yang baru dipilih
      if (!newCoefficients[itemId]) {
        const item = rabReviewDataAdd.find((rabItem) => rabItem.id === itemId);
        newCoefficients[itemId] = item?.overheadKoefisien || 0.1;
      }
    } else {
      newSelectedItems = selectedRabItemsAdd.filter((id) => id !== itemId);
      // Hapus koefisien untuk item yang tidak dipilih
      delete newCoefficients[itemId];
    }

    setSelectedRabItemsAdd(newSelectedItems);
    setItemCoefficientsAdd(newCoefficients);

    // Apply koefisien berdasarkan kondisi terbaru
    updateRabDataWithCoefficientAdd(newCoefficients);
  };

  const handleRabItemSelectEdit = (itemId: string, checked: boolean) => {
    let newSelectedItems: string[];

    if (checked) {
      newSelectedItems = [...selectedRabItemsEdit, itemId];
    } else {
      newSelectedItems = selectedRabItemsEdit.filter((id) => id !== itemId);
    }

    setSelectedRabItemsEdit(newSelectedItems);

    // Apply koefisien berdasarkan kondisi terbaru
    if (biddingDataEdit.koefisien && biddingDataEdit.koefisien !== 1) {
      updateRabDataWithCoefficientEdit(biddingDataEdit.koefisien);
    } else if (biddingDataEdit.koefisien === 1 || !biddingDataEdit.koefisien) {
      // Jika koefisien = 1 atau tidak diisi, kembalikan ke harga asli
      if (newSelectedItems.length === 0) {
        // Tidak ada yang dipilih, kembalikan semua ke harga asli
        setAdjustedRabReviewDataEdit(rabReviewDataEdit);
        setTotalRabValue(
          rabReviewDataEdit.reduce(
            (acc, curr) =>
              acc +
              (typeof curr.totalHarga === "number"
                ? curr.totalHarga
                : parseFloat(curr.totalHarga || "0")),
            0
          )
        );
      } else {
        // Ada yang dipilih, apply koefisien hanya untuk yang dipilih
        updateRabDataWithCoefficientEdit(1);
      }
    }
  };

  const updateRabDataWithCoefficientEdit = (coefficients: {
    [key: string]: number;
  }) => {
    if (!rabReviewDataEdit.length) return;

    const adjustedData = rabReviewDataEdit.map((item) => {
      const itemId = item.id || "";
      const isSelected = selectedRabItemsEdit.includes(itemId);

      // GUNAKAN KOEFISIEN DARI PARAMETER
      const itemCoefficient =
        coefficients[itemId] !== undefined
          ? coefficients[itemId]
          : item.overheadKoefisien || 0.1;

      const safeCoefficient = isNaN(itemCoefficient) ? 0.1 : itemCoefficient;

      // PERBAIKAN: Dapatkan HARGA DASAR ASLI dari AHS
      const hargaDasarAHS = item.ahs?.totalJumlahHargaABC
        ? parseFloat(item.ahs.totalJumlahHargaABC)
        : parseFloat(item.hargaSatuan || "0") /
          (1 + (item.overheadKoefisien || 0.1));

      const baseVolume = parseFloat(item.volume || "0");

      // HITUNG HARGA BARU berdasarkan koefisien
      const adjustedHargaSatuan = hargaDasarAHS * (1 + safeCoefficient);
      const adjustedTotalHarga = adjustedHargaSatuan * baseVolume;

      // UPDATE adjustment prices
      setAdjustmentTotalPrices((prev) => ({
        ...prev,
        [itemId]: adjustedTotalHarga,
      }));
      setAdjustmentUnitPrices((prev) => ({
        ...prev,
        [itemId]: adjustedHargaSatuan,
      }));

      return {
        ...item,
        hargaSatuan: adjustedHargaSatuan,
        totalHarga: adjustedTotalHarga,
        baseHargaSatuan: hargaDasarAHS,
        customCoefficient: safeCoefficient,
        isSelected: isSelected,
        hasCustomCoefficient: coefficients[itemId] !== undefined,
      };
    });

    setAdjustedRabReviewDataEdit(adjustedData);

    // Hitung total baru dari adjustmentTotalPrices
    const newTotal = Object.values(adjustmentTotalPrices).reduce(
      (acc, curr) => acc + curr,
      0
    );

    console.log("New total from coefficient update:", newTotal);
    setTotalRabValueEdit(newTotal);
    setTotalRabValue(newTotal);
  };

  const handleInputChangeEdit = (event) => {
    const { name, value } = event.target;

    setBiddingDataEdit((prevData) => {
      const newData = { ...prevData, [name]: value };

      // Jika koefisien berubah, update data RAB review
      if (name === "koefisien") {
        const koefisienValue = parseFloat(value) || 1;

        // Jika ada item yang dipilih, apply koefisien hanya untuk yang dipilih
        if (selectedRabItemsEdit.length > 0) {
          updateRabDataWithCoefficientEdit(koefisienValue);
        } else {
          // Jika tidak ada yang dipilih, kembalikan ke harga asli
          setAdjustedRabReviewDataEdit(rabReviewDataEdit);
          setTotalRabValue(
            rabReviewDataEdit.reduce(
              (acc, curr) =>
                acc +
                (typeof curr.totalHarga === "number"
                  ? curr.totalHarga
                  : parseFloat(curr.totalHarga || "0")),
              0
            )
          );
        }
      }

      return newData;
    });
  };

  const handleEditFileUpload = (file: File) => {
    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const maxSize = 5 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        /* error message */
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        /* error message */
      });
      return;
    }

    // Pisahkan handling untuk image vs non-image
    let newPreviewUrl: string;

    if (file.type.startsWith("image/")) {
      // Untuk image, buat blob URL
      newPreviewUrl = URL.createObjectURL(file);
    } else {
      // Untuk non-image (PDF, Word, Excel), gunakan flag
      newPreviewUrl = "file_uploaded";
    }

    setBiddingDataEdit((prev) => ({
      ...prev,
      file: file,
      previewUrl: newPreviewUrl,
    }));
  };

  const handleCoefficientChangeAdd = (
    itemId: string,
    newCoefficient: number
  ) => {
    const updatedCoefficients = {
      ...itemCoefficientsAdd,
      [itemId]: newCoefficient,
    };

    setItemCoefficientsAdd(updatedCoefficients);
    updateRabDataWithCoefficientAdd(updatedCoefficients);
  };

  const handleCoefficientChangeEdit = (
    itemId: string,
    newCoefficient: number | string
  ) => {
    // PERBAIKAN: Pastikan newCoefficient adalah number yang valid
    const numericCoefficient =
      typeof newCoefficient === "number"
        ? newCoefficient
        : parseFloat(newCoefficient) || 0;

    // Batasi nilai antara -1 dan 10 (izinkan diskon hingga kebawah modal)
    const clampedCoefficient = Math.max(-1, Math.min(10, numericCoefficient));

    const updatedCoefficients = {
      ...itemCoefficientsEdit,
      [itemId]: clampedCoefficient,
    };

    setItemCoefficientsEdit(updatedCoefficients);

    // Hitung harga baru untuk item ini
    const item = rabReviewDataEdit.find((rabItem) => rabItem.id === itemId);
    if (item) {
      // PERBAIKAN: Dapatkan HARGA DASAR ASLI dari AHS (tanpa overhead apapun)
      const hargaDasarAHS = item.ahs?.hargaSatuan
        ? parseFloat(item.ahs.hargaSatuan)
        : parseFloat(item.hargaSatuan || "0") /
          (1 + (item.overheadKoefisien || 0.1));

      const baseVolume = parseFloat(item.volume || "0");

      // PERBAIKAN: Hitung harga satuan = harga dasar AHS * (1 + koefisien)
      const adjustedHargaSatuan = hargaDasarAHS * (1 + clampedCoefficient);
      const adjustedTotalHarga = adjustedHargaSatuan * baseVolume;

      console.log(`Koefisien ${clampedCoefficient}:`, {
        hargaDasarAHS,
        adjustedHargaSatuan,
        adjustedTotalHarga,
        volume: baseVolume,
      });

      // Update adjustment prices untuk item ini saja
      setAdjustmentTotalPrices((prev) => ({
        ...prev,
        [itemId]: adjustedTotalHarga,
      }));
      setAdjustmentUnitPrices((prev) => ({
        ...prev,
        [itemId]: adjustedHargaSatuan,
      }));

      // Update data yang ditampilkan
      setAdjustedRabReviewDataEdit((prev) =>
        prev.map((rabItem) =>
          rabItem.id === itemId
            ? {
                ...rabItem,
                hargaSatuan: adjustedHargaSatuan,
                totalHarga: adjustedTotalHarga,
                customCoefficient: clampedCoefficient,
                baseHargaSatuan: hargaDasarAHS, // Simpan harga dasar untuk referensi
              }
            : rabItem
        )
      );

      // Hitung ulang total dari semua adjustmentTotalPrices
      const newTotal = Object.values({
        ...adjustmentTotalPrices,
        [itemId]: adjustedTotalHarga,
      }).reduce((acc, curr) => acc + curr, 0);

      setTotalRabValueEdit(newTotal);
      setTotalRabValue(newTotal);
    }
  };

  const handleCloseEdit = () => {
    setOpenEditBiddingDialog(false);
    setIsEditing(false);
    setSelectedBiddingId(null);
    // Reset RAB review data untuk edit dialog
    setSelectedRabItemsEdit([]);
    setRabReviewDataEdit([]);
    setTotalRabValue(0);
    // Reset koefisien ke default
    setAdjustedRabReviewDataEdit([]);
  };

  function terbilang(nilai) {
    const angka = [
      "",
      "Satu",
      "Dua",
      "Tiga",
      "Empat",
      "Lima",
      "Enam",
      "Tujuh",
      "Delapan",
      "Sembilan",
      "Sepuluh",
      "Sebelas",
    ];

    function convert(n) {
      n = Math.floor(n);
      if (n < 12) return angka[n];
      else if (n < 20) return convert(n - 10) + " Belas";
      else if (n < 100)
        return convert(Math.floor(n / 10)) + " Puluh " + convert(n % 10);
      else if (n < 200) return "Seratus " + convert(n - 100);
      else if (n < 1000)
        return convert(Math.floor(n / 100)) + " Ratus " + convert(n % 100);
      else if (n < 2000) return "Seribu " + convert(n - 1000);
      else if (n < 1000000)
        return convert(Math.floor(n / 1000)) + " Ribu " + convert(n % 1000);
      else if (n < 1000000000)
        return (
          convert(Math.floor(n / 1000000)) + " Juta " + convert(n % 1000000)
        );
      else if (n < 1000000000000)
        return (
          convert(Math.floor(n / 1000000000)) +
          " Miliar " +
          convert(n % 1000000000)
        );
      else return "Angka terlalu besar";
    }

    return convert(nilai).replace(/\s+/g, " ").trim();
  }

  const [errorsEdit, setErrorsEdit] = useState({
    projectName: false,
    rabName: false,
    submissionDate: false,
    projectProcess: false,
    vendorNames: false,
    vendorProjectValue: false,
    status: false,
  });

  const validateFormEdit = () => {
    const newErrors: any = {};

    const mandatoryFields = [
      "projectName",
      "rabName",
      "submissionDate",
      "projectProcess",
      "vendorNames",
      "vendorProjectValue",
      "status",
    ];

    // Jika tipe inorganic → wajib isi bidding company
    // if (biddingDataEdit.biddingType === "inorganic") {
    //   mandatoryFields.push("company");
    // }

    // Validasi setiap field
    mandatoryFields.forEach((field) => {
      if (
        !biddingDataEdit[field] ||
        biddingDataEdit[field].toString().trim() === ""
      ) {
        newErrors[field] = true;
      }
    });

    setErrorsEdit(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const generateDisplayPaymentFilename = (projectName: string): string => {
    if (!projectName) return "Bidding_unknown_project.pdf";

    // Cari project yang sesuai
    const selectedProject = projectOptions.find(
      (opt) => opt.projectName === projectName
    );

    const actualProjectName = selectedProject?.projectName || projectName;

    // Bersihkan nama project untuk nama file
    const cleanProjectName = actualProjectName
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "")
      .substring(0, 50);

    return `Bidding_${cleanProjectName}.pdf`;
  };

  // Handle file deletion for edit mode
  const handleDeleteProposalEdit = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        if (biddingDataEdit.id) {
          await deleteProposalFile(biddingDataEdit.id);
        }

        // Clear file from state
        setBiddingDataEdit((prev) => ({
          ...prev,
          file: null,
          previewUrl: "",
          vendorProposalUrl: "",
        }));

        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      } catch (error) {
        console.error("Error deleting file:", error);
        Swal.fire({
          icon: "error",
          title: "Delete failed",
          text: error.response?.data?.message || "Failed to delete file",
        });
      }
    }
  };

  const handleProjectChangeEdit = (event, newValue) => {
    if (newValue) {
      setBiddingDataEdit((prev) => ({
        ...prev,
        projectId: newValue.projectReferenceId,
        projectListingId: newValue.id,
        projectName: newValue.projectName,
        clientName: newValue.source,
        projectType: newValue.projectType,
        constructionPhase: newValue.constructionPhase,
        projectAddress: newValue.projectAddress,
        latitude: newValue.latitude,
        longitude: newValue.longitude,
        biddingRegion: newValue.region,
        biddingCity: newValue.city,
        biddingDistrict: newValue.district,
      }));
    } else {
      // Reset all fields if no project selected
      setBiddingDataEdit((prev) => ({
        ...prev,
        projectId: "",
        projectListingId: "",
        projectName: "",
        clientName: "",
        projectType: "",
        constructionPhase: "",
        projectAddress: "",
        latitude: "",
        longitude: "",
        biddingRegion: "",
        biddingCity: "",
        biddingDistrict: "",
      }));
    }
  };

  // Fungsi yang sudah ada, pastikan return format-nya konsisten
  const getBiddingAdjustmentsByBiddingId = async (biddingId: string) => {
    try {
      const allAdjustments = await viewBiddingAdjustment();

      // Pastikan kita selalu mendapatkan array
      const adjustmentsArray = Array.isArray(allAdjustments)
        ? allAdjustments
        : allAdjustments.data || [];

      // Filter berdasarkan biddingId
      const filteredAdjustments = adjustmentsArray.filter(
        (adj) => adj.biddingId === biddingId
      );

      console.log(
        `Found ${filteredAdjustments.length} adjustments for bidding ${biddingId}`
      );

      // Pastikan return format konsisten
      return {
        data: filteredAdjustments,
        total: filteredAdjustments.length,
      };
    } catch (error) {
      console.error("Error fetching bidding adjustments by biddingId:", error);
      // Return empty array format yang konsisten
      return { data: [], total: 0 };
    }
  };

  const handleSaveEdit = async () => {
    try {
      // Prepare the payload matching createBidding structure
      const payload = {
        id: biddingDataEdit.id,
        projectListingId: biddingDataEdit.projectListingId,
        clientName: biddingDataEdit.clientName,
        projectId: biddingDataEdit.projectId,
        projectType: biddingDataEdit.projectType,
        projectAddress: biddingDataEdit.projectAddress,
        constructionPhase: biddingDataEdit.constructionPhase,
        rabId: biddingDataEdit.rabId,
        bidAmount: biddingDataEdit.bidAmount,
        submissionDate: biddingDataEdit.submissionDate,
        rabValue: biddingDataEdit.rabValue,
        startDate: biddingDataEdit.startDate,
        endDate: biddingDataEdit.endDate,
        projectProcess: biddingDataEdit.projectProcess,
        vendorNames: biddingDataEdit.vendorNames,
        vendorProjectValue: biddingDataEdit.vendorProjectValue,
        status: biddingDataEdit.status,
        latitude: biddingDataEdit.latitude,
        longitude: biddingDataEdit.longitude,
        koefisien: biddingDataEdit.koefisien,
        biddingRegion: biddingDataEdit.biddingRegion,
        biddingCity: biddingDataEdit.biddingCity,
        biddingDistrict: biddingDataEdit.biddingDistrict,
      };

      // Step 1: Update the bidding data
      await updateBidding(payload);

      // Step 2: Upload proposal file if available
      if (biddingDataEdit.file) {
        await uploadProposal(payload.id, biddingDataEdit.file);
      }

      // Step 3: Handle bidding adjustments - UPDATE existing instead of DELETE + CREATE
      if (rabReviewDataEdit.length > 0) {
        // Get existing adjustments for this bidding
        const existingAdjustmentsResponse =
          await getBiddingAdjustmentsByBiddingId(biddingDataEdit.id);
        const existingAdjustments = existingAdjustmentsResponse.data || [];

        console.log("Existing adjustments found:", existingAdjustments.length);

        const updatePromises = [];
        const createPromises = [];

        // Process each RAB item
        for (const item of rabReviewDataEdit) {
          const itemId = item.id || "";
          const isSelected = selectedRabItemsEdit.includes(itemId);

          // GUNAKAN KOEFISIEN DARI STATE YANG SUDAH DIPARSE
          const koefisien =
            itemCoefficientsEdit[itemId] !== undefined
              ? itemCoefficientsEdit[itemId]
              : item.overheadKoefisien || 0.1;

          // Hitung harga dasar (tanpa overhead)
          const baseHargaSatuan =
            item.baseHargaSatuan ||
            parseFloat(item.hargaSatuan || "0") /
              (1 + (item.overheadKoefisien || 0.1));

          const baseVolume = parseFloat(item.volume || "0");

          // PERBAIKAN: Gunakan totalHarga dari adjusted data untuk konsistensi
          const totalHarga =
            adjustedRabReviewDataEdit.find((adj) => adj.id === itemId)
              ?.totalHarga || baseHargaSatuan * (1 + koefisien) * baseVolume;

          const adjustmentData = {
            biddingId: payload.id,
            rabId: biddingDataEdit.rabId,
            rabDetailId: itemId,
            ahsId: item.ahsId || "",
            koefisien: koefisien, // Send as number
            totalHarga:
              typeof totalHarga === "number"
                ? totalHarga
                : parseFloat(totalHarga),
            isCustom: isSelected && itemCoefficientsEdit[itemId] !== undefined,
          };

          // Cari apakah adjustment sudah ada untuk item ini
          const existingAdjustment = existingAdjustments.find(
            (adj) => adj.rabDetailId === itemId && adj.biddingId === payload.id
          );

          if (existingAdjustment) {
            // UPDATE existing adjustment
            console.log(
              `Updating existing adjustment for rabDetailId: ${itemId}`
            );
            updatePromises.push(
              updateBiddingAdjustment(existingAdjustment.id, adjustmentData)
            );
          } else {
            // CREATE new adjustment jika tidak ada
            console.log(`Creating new adjustment for rabDetailId: ${itemId}`);
            createPromises.push(createBiddingAdjustment(adjustmentData));
          }
        }

        // Handle adjustments that need to be deleted (items that were removed from RAB)
        const currentRabDetailIds = rabReviewDataEdit
          .map((item) => item.id || "")
          .filter(Boolean);
        const adjustmentsToDelete = existingAdjustments.filter(
          (adj) => !currentRabDetailIds.includes(adj.rabDetailId)
        );

        const deletePromises = adjustmentsToDelete.map((adjustment) =>
          deleteBiddingAdjustment(adjustment.id)
        );

        console.log(
          `Update: ${updatePromises.length}, Create: ${createPromises.length}, Delete: ${deletePromises.length}`
        );

        // Execute all operations
        await Promise.all([
          ...updatePromises,
          ...createPromises,
          ...deletePromises,
        ]);

        console.log("All adjustment operations completed successfully");
      } else {
        // Jika tidak ada data RAB, hapus semua adjustments untuk bidding ini
        try {
          const existingAdjustments = await getBiddingAdjustmentsByBiddingId(
            biddingDataEdit.id
          );
          if (
            existingAdjustments.data &&
            Array.isArray(existingAdjustments.data)
          ) {
            const deletePromises = existingAdjustments.data.map((adjustment) =>
              deleteBiddingAdjustment(adjustment.id)
            );
            await Promise.all(deletePromises);
            console.log("All adjustments deleted due to empty RAB data");
          }
        } catch (error) {
          console.warn("Failed to delete existing adjustments:", error);
        }
      }

      Swal.fire({
        icon: "success",
        title: "Bidding Updated Successfully",
        confirmButtonColor: "#0F62FE",
      });

      setOpenEditBiddingDialog(false);
      reloadBidding();
    } catch (error) {
      console.error("Error updating bidding:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.response?.data?.message || "Failed to update bidding data",
      });
    }
  };

  useEffect(() => {
    if (
      openEditBiddingDialog &&
      Object.keys(adjustmentTotalPrices).length > 0
    ) {
      const totalFromAdjustments = Object.values(adjustmentTotalPrices).reduce(
        (acc, curr) => acc + curr,
        0
      );

      console.log(
        "Setting total from adjustments in useEffect:",
        totalFromAdjustments
      );

      // Update semua state total
      setTotalRabValueEdit(totalFromAdjustments);
      setTotalRabValue(totalFromAdjustments);
    }
  }, [openEditBiddingDialog, adjustmentTotalPrices]);

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Bidding List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => handleDeleteBidding(true)} // Pindahkan fungsi delete di sini
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button>

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={handleOpenAddDialog} // Ganti dari setOpenAddEmployeeDialog
          >
            Add New Bidding
          </Button>
        </Box>
      </Box>

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Bidding
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.biddingId)
                    )
                  }
                />
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Name</strong>
                {sortConfig.orderBy === "projectName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("rabName")}
                style={{ cursor: "pointer" }}
              >
                <strong>RAB Name</strong>
                {sortConfig.orderBy === "rabName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("rabValue")}
                style={{ cursor: "pointer" }}
              >
                <strong>Bid Ammount</strong>
                {sortConfig.orderBy === "rabValue" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("submissionDate")}
                style={{ cursor: "pointer" }}
              >
                <strong>Submission Date</strong>
                {sortConfig.orderBy === "submissionDate" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("clientName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Source</strong>
                {sortConfig.orderBy === "clientName" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Type</strong>
                {sortConfig.orderBy === "projectType" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("constructionPhase")}
                style={{ cursor: "pointer" }}
              >
                <strong>Phase</strong>
                {sortConfig.orderBy === "constructionPhase" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectProcess")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Process</strong>
                {sortConfig.orderBy === "projectProcess" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("vendorNames")}
                style={{ cursor: "pointer" }}
              >
                <strong>Vendor Names</strong>
                {sortConfig.orderBy === "vendorNames" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("status")}
                style={{ cursor: "pointer" }}
              >
                <strong>Bidding Status</strong>
                {sortConfig.orderBy === "status" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={9} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>
                      {projectOptions.find(
                        (project) => project.id === row.projectName // Changed from projectListingId
                      )?.projectName ||
                        row.projectName ||
                        "-"}{" "}
                      {/* Fallback to row data */}
                    </strong>
                  </TableCell>
                  <TableCell>
                    {rabOptions.find((rab) => rab.id === row.rabName)
                      ?.rabName ||
                      row.rabName ||
                      "-"}
                  </TableCell>
                  <TableCell>
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(parseFloat(row.rabValue))}
                  </TableCell>
                  {/* {row.rabValue}</TableCell> */}
                  <TableCell>{row.submissionDate}</TableCell>
                  <TableCell>{row.clientName}</TableCell>
                  <TableCell>{row.projectType}</TableCell>
                  <TableCell>{row.constructionPhase}</TableCell>
                  <TableCell>{row.projectProcess}</TableCell>
                  <TableCell>
                    {Array.isArray(row.vendorNames)
                      ? row.vendorNames
                          .map(
                            (id) =>
                              vendors.find((v) => v.vendorId === id)?.vendorName
                          )
                          .filter(Boolean)
                          .join(", ") || "-"
                      : vendors.find((v) => v.vendorId === row.vendorNames)
                          ?.vendorName || "-"}
                  </TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell className="tableCell">
                    <IconButton onClick={() => handleOpenEditDialog(row)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Render input berdasarkan jenis field */}
                {(() => {
                  // Field dengan dropdown khusus
                  if (filter.field === "projectName") {
                    return (
                      <Autocomplete
                        options={projectOptions}
                        getOptionLabel={(option) => option.projectName || ""}
                        value={
                          projectOptions.find(
                            (opt) => opt.projectName === filter.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.projectName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Project Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                          />
                        )}
                      />
                    );
                  } else if (filter.field === "rabName") {
                    return (
                      <Autocomplete
                        loading={loadingRabs}
                        options={rabOptions}
                        getOptionLabel={(option) => option.rabName || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        value={
                          rabOptions.find(
                            (opt) => opt.rabName === filter.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.rabName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="RAB Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                            placeholder="Select RAB"
                          />
                        )}
                      />
                    );
                  } else if (filter.field === "vendorNames") {
                    return (
                      <Autocomplete
                        loading={loadingVendors}
                        options={vendors}
                        getOptionLabel={(option) => option.vendorName || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.vendorId === value.vendorId
                        }
                        value={
                          vendors.find((v) => v.vendorName === filter.value) ||
                          null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.vendorName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Vendor Name"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                            placeholder="Select Vendor"
                          />
                        )}
                      />
                    );
                  }

                  // Field dengan input tanggal khusus
                  else if (filter.field === "submissionDate") {
                    return (
                      <TextField
                        type="date"
                        label="Submission Date"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    );
                  }

                  // Field dengan input number khusus
                  else if (filter.field === "rabValue") {
                    return (
                      <TextField
                        type="number"
                        label="Bid Amount"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }

                  // Default text input untuk field lainnya
                  else {
                    return (
                      <TextField
                        label="Value"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }
                })()}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================== POPUP Add New Bidding =========================== */}
      <Dialog
        open={openAddBiddingDialog}
        onClose={() => setOpenAddBiddingDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Add New Bidding
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Bidding ID */}
              <Grid item xs={6} sm={6}>
                {/* Form Input Section */}
                <Box sx={{ flex: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    PROJECT LISTING
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={projectOptions}
                    getOptionLabel={(option) => option.projectName || ""}
                    value={
                      projectOptions.find(
                        (opt) => opt.id === biddingDataAdd.projectListingId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setBiddingDataAdd((prev) => ({
                        ...prev,
                        projectListingId: newValue?.id || "",
                        projectName: newValue?.projectName || "",
                      }));
                      // Then call your handleProjectChange
                      handleProjectChange({
                        target: {
                          name: "projectListingId",
                          value: newValue?.id || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name"
                        placeholder="Select project"
                        fullWidth
                        error={!biddingDataAdd.projectListingId}
                        helperText={
                          !biddingDataAdd.projectListingId
                            ? "Mandatory Field"
                            : ""
                        }
                      />
                    )}
                  />
                  <TextField
                    fullWidth
                    label="Client Name"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataAdd.clientName || ""}
                    sx={{ mb: 1 }}
                    name="clientName"
                    placeholder="Enter Client Name"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project ID / Refference"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataAdd.projectId || ""}
                    sx={{ mb: 1 }}
                    name="projectId"
                    placeholder="Enter Project ID / Refference"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project Type"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataAdd.projectType || ""}
                    sx={{ mb: 1 }}
                    name="projectType"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Construction Phase"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataAdd.constructionPhase || ""}
                    sx={{ mb: 1 }}
                    name="constructionPhase"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mt: 51 }}
                  >
                    RAB
                  </Typography>
                  <Autocomplete
                    loading={loadingRabs}
                    fullWidth
                    options={rabOptions}
                    getOptionLabel={(option: RabOption) => option.rabName}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      rabOptions.find(
                        (opt) =>
                          opt.id === biddingDataAdd.rabId ||
                          opt.rabName === biddingDataAdd.rabName
                      ) || null
                    }
                    onChange={async (event, newValue: RabOption | null) => {
                      const rabId = newValue?.id || "";

                      setBiddingDataAdd((prev) => ({
                        ...prev,
                        rabId: rabId,
                        rabName: newValue?.rabName || "",
                        rabValue: newValue
                          ? parseFloat(newValue.totalPrice) || 0
                          : 0,
                        startDate:
                          newValue?.project?.startDate || prev.startDate,
                        endDate: newValue?.project?.endDate || prev.endDate,
                      }));

                      // Panggil handleRabChangeAdd untuk load RAB detail
                      await handleRabChangeAdd(rabId);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="RAB Name"
                        placeholder="Select RAB"
                        fullWidth
                        error={!biddingDataAdd.rabId}
                        helperText={
                          !biddingDataAdd.rabId ? "Mandatory Field" : ""
                        }
                      />
                    )}
                  />
                  <TextField
                    fullWidth
                    label="Bid Amount"
                    name="bidAmount"
                    type="number"
                    placeholder="Bid Amount"
                    sx={{ mt: 1 }}
                    value={biddingDataAdd.bidAmount || 0}
                    onChange={handleInputChangeAdd}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                    }}
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Submission Date"
                      format="YYYY-MM-DD"
                      value={
                        biddingDataAdd.submissionDate
                          ? dayjs(biddingDataAdd.submissionDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeAdd({
                          target: {
                            name: "submissionDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mt: 17, mb: 1 },
                          name: "submissionDate",
                          error: !biddingDataAdd.submissionDate,
                          helperText: !biddingDataAdd.submissionDate
                            ? "Mandatory Field"
                            : "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      gap: 3,
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #aaa",
                      padding: 4,
                      borderRadius: "12px",
                      backgroundColor: "#fafafa",
                      textAlign: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => fileInputRef.current?.click()}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                        handleFileUpload(e.dataTransfer.files[0]);
                      }
                    }}
                  >
                    {previewUrl ? (
                      <>
                        <GridOn fontSize="large" color="primary" />
                        <Typography variant="body2" mt={1}>
                          {biddingDataAdd.file?.name || "Uploaded PDF"}
                        </Typography>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            backgroundColor: "rgba(255,255,255,0.7)",
                            "&:hover": {
                              backgroundColor: "rgba(255,255,255,0.9)",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setPreviewUrl("");
                            setBiddingDataAdd((prev) => ({
                              ...prev,
                              file: null,
                            }));
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <GridOn fontSize="large" color="action" />
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          mt={1}
                        >
                          Drag & drop or click to upload proposal (PDF,
                          CSV/XLS/XLSX, WORD)
                        </Typography>
                      </>
                    )}
                    <input
                      hidden
                      accept=".pdf,.doc,.docx,.xls,.xlsx"
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handleFileUpload(e.target.files[0]);
                        }
                      }}
                    />
                    <Typography variant="caption" mt={1}>
                      Max size: 5MB (PDF, CSV/XLS/XLSX, WORD)
                    </Typography>
                  </Box>
                </Box>
                {/* <TextField
                  fullWidth
                  label="Koefisien"
                  name="koefisien"
                  type="number"
                  placeholder="Koefisien"
                  sx={{ mt: 2 }}
                  value={biddingDataAdd.koefisien || 0.1}
                  onChange={handleInputChangeAdd}
                  InputProps={{
                    inputProps: {
                      min: 0.1,
                      max: 10,
                      step: 0.01,
                    },
                  }}
                  disabled
                  helperText={`Nilai koefisien untuk mengadjust harga (Overhead default: ${
                    rabReviewDataAdd[0]?.overheadKoefisien || 0.1
                  })`}
                /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Typography variant="subtitle1" fontWeight="bold">
                  PROJECT ADDRESS
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter Project Address"
                  sx={{ textAlign: "left", mt: 1 }}
                  value={biddingDataAdd.projectAddress}
                  name="projectAddress"
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={biddingDataAdd.latitude}
                    longitude={biddingDataAdd.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      setBiddingDataAdd({
                        ...biddingDataAdd,
                        latitude: lat.toString(),
                        longitude: lng.toString(),
                      });
                      // }
                      // else {
                      //   setOfficeData({ ...officeData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={biddingDataAdd.latitude}
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={biddingDataAdd.longitude}
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                </Box>
                <TextField
                  fullWidth
                  label="Region"
                  margin="normal"
                  variant="outlined"
                  placeholder="Enter Bidding Country"
                  value={biddingDataAdd.biddingRegion}
                  sx={{ mb: 1 }}
                  name="biddingRegion"
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="City"
                  name="biddingCity"
                  placeholder="Enter Bidding City"
                  sx={{ mb: 1 }}
                  value={biddingDataAdd.biddingCity}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="District"
                  name="biddingDistrict"
                  placeholder="Enter Bidding District"
                  sx={{ mb: 1 }}
                  value={biddingDataAdd.biddingDistrict}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Rab Value"
                  name="rabValue"
                  placeholder="Rab Value"
                  sx={{ mt: 13, mb: 1 }}
                  value={biddingDataAdd.rabValue || 0}
                  onChange={handleInputChangeAdd}
                  InputProps={{
                    readOnly: true, // Make read-only if it should only come from RAB selection
                    startAdornment: (
                      <InputAdornment position="start">Rp</InputAdornment>
                    ),
                  }}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Start Date"
                  name="startDate"
                  placeholder="Start date"
                  sx={{ mb: 1 }}
                  value={biddingDataAdd.startDate || ""}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  fullWidth
                  label="End Date"
                  name="endDate"
                  placeholder="End date"
                  sx={{ mb: 1 }}
                  value={biddingDataAdd.endDate || ""}
                  onChange={handleInputChangeAdd}
                  disabled
                />
                <TextField
                  select
                  fullWidth
                  label="Project Process"
                  name="projectProcess"
                  placeholder="Enter Project Process"
                  sx={{ mt: 8, mb: 1 }}
                  value={biddingDataAdd.projectProcess}
                  onChange={handleInputChangeAdd}
                  error={!biddingDataAdd.projectProcess}
                  helperText={
                    !biddingDataAdd.projectProcess ? "Mandatory Field" : ""
                  }
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Swadaya">Swadaya</MenuItem>
                  <MenuItem value="Partial">Partial</MenuItem>
                  <MenuItem value="Full Vendor">Full Vendor</MenuItem>
                </TextField>
                {/* Vendor Names Section */}
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ mt: 2 }}
                    >
                      Vendor Names
                      {biddingDataAdd.vendorNames.every((v) => !v) && (
                        <FormHelperText error sx={{ ml: 1 }}>
                          Mandatory Field
                        </FormHelperText>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ mt: 2 }}
                    >
                      Vendor Values
                      {biddingDataAdd.vendorProjectValue.every((v) => !v) && (
                        <FormHelperText error sx={{ ml: 1 }}>
                          Mandatory Field
                        </FormHelperText>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>

                {biddingDataAdd.vendorNames.map((vendorId, index) => {
                  const availableVendors = vendors.filter(
                    (v) =>
                      !biddingDataAdd.vendorNames.includes(v.vendorId) ||
                      v.vendorId === vendorId
                  );
                  const projectValue = Array.isArray(
                    biddingDataAdd.vendorProjectValue
                  )
                    ? biddingDataAdd.vendorProjectValue[index] || ""
                    : index === 0
                    ? biddingDataAdd.vendorProjectValue || ""
                    : "";

                  return (
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      key={index}
                      sx={{ mb: 1 }}
                    >
                      <Grid item xs={6}>
                        <Autocomplete
                          options={availableVendors}
                          getOptionLabel={(option) => option.vendorName || ""}
                          value={
                            vendors.find((v) => v.vendorId === vendorId) || null
                          }
                          onChange={(_, newValue) => {
                            handleVendorChangeAdd(
                              index,
                              newValue?.vendorId || ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Vendor"
                              fullWidth
                              margin="dense"
                              error={!vendorId && index === 0}
                              helperText={
                                !vendorId && index === 0
                                  ? "Please select at least one vendor"
                                  : ""
                              }
                            />
                          )}
                          disabled={loadingVendors}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label="Project Value"
                          placeholder="Enter Value"
                          value={projectValue}
                          onChange={(e) => {
                            const newValues = [
                              ...(Array.isArray(
                                biddingDataAdd.vendorProjectValue
                              )
                                ? biddingDataAdd.vendorProjectValue
                                : [biddingDataAdd.vendorProjectValue || ""]),
                            ];
                            newValues[index] = e.target.value;

                            setBiddingDataAdd((prev) => ({
                              ...prev,
                              vendorProjectValue: newValues,
                            }));
                          }}
                          error={!projectValue && index === 0}
                          helperText={
                            !projectValue && index === 0
                              ? "Please enter project value"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={2}>
                        {index === biddingDataAdd.vendorNames.length - 1 ? (
                          <IconButton onClick={addVendorField} color="primary">
                            <Add />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() => removeVendorField(index)}
                            color="error"
                          >
                            <DeleteOutline />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
                <TextField
                  select
                  fullWidth
                  label="Bidding Stauts"
                  name="status"
                  placeholder="Enter Bidding Stauts"
                  sx={{ mb: 1 }}
                  value={biddingDataAdd.status}
                  onChange={handleInputChangeAdd}
                  error={!biddingDataAdd.status}
                  helperText={!biddingDataAdd.status ? "Mandatory Field" : ""}
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Submit">Submit</MenuItem>
                  <MenuItem value="Review">Review</MenuItem>
                  <MenuItem value="Shortlisted">Shortlisted</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                  <MenuItem value="Awarded">Awarded</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>
          {/* RAB Review Section */}
          <Box sx={{ mt: 3, width: "100%" }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              RAB Review
            </Typography>

            {loadingRabReviewAdd ? (
              <Typography>Loading RAB details...</Typography>
            ) : rabReviewDataAdd.length === 0 ? (
              biddingDataAdd.rabId ? (
                <Typography>
                  No RAB details available for selected RAB
                </Typography>
              ) : (
                <Typography>Select a RAB to view details</Typography>
              )
            ) : (
              <>
                <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
                  {selectedRabItemsAdd.length} of {rabReviewDataAdd.length}{" "}
                  items selected
                </Typography>
                <Table size="small" sx={{ mb: 2 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selectedRabItemsAdd.length > 0 &&
                            selectedRabItemsAdd.length < rabReviewDataAdd.length
                          }
                          checked={
                            rabReviewDataAdd.length > 0 &&
                            selectedRabItemsAdd.length ===
                              rabReviewDataAdd.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              // SELECT ALL untuk Add
                              const allIds = rabReviewDataAdd.map(
                                (item) => item.id || ""
                              );

                              // Set koefisien default untuk semua item
                              const newCoefficients = {
                                ...itemCoefficientsAdd,
                              };
                              allIds.forEach((id) => {
                                if (newCoefficients[id] === undefined) {
                                  const item = rabReviewDataAdd.find(
                                    (rabItem) => rabItem.id === id
                                  );
                                  newCoefficients[id] =
                                    item?.overheadKoefisien || 0.1;
                                }
                              });

                              setSelectedRabItemsAdd(allIds);
                              setItemCoefficientsAdd(newCoefficients);
                              updateRabDataWithCoefficientAdd(newCoefficients);
                            } else {
                              // UNSELECT ALL untuk Add
                              setSelectedRabItemsAdd([]);
                              // Reset ke harga asli ketika tidak ada yang dipilih
                              setAdjustedRabReviewDataAdd(rabReviewDataAdd);
                              setTotalRabValueAdd(
                                rabReviewDataAdd.reduce(
                                  (acc, curr) => acc + (curr.totalHarga || 0),
                                  0
                                )
                              );
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>No</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Volume</TableCell>
                      <TableCell>Unit</TableCell>
                      <TableCell>New Coefficient</TableCell>
                      <TableCell>Unit Price</TableCell>
                      <TableCell>Total Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adjustedRabReviewDataAdd.map((item, index) => {
                      const isSelected = selectedRabItemsAdd.includes(
                        item.id || ""
                      );

                      // Gunakan coefficient dari state Add, bukan Edit
                      const currentCoefficient =
                        itemCoefficientsAdd[item.id || ""] !== undefined
                          ? itemCoefficientsAdd[item.id || ""]
                          : item.overheadKoefisien || 0.1;

                      return (
                        <TableRow key={item.id || index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isSelected}
                              onChange={(e) => {
                                handleRabItemSelectAdd(
                                  item.id || "",
                                  e.target.checked
                                );
                              }}
                            />
                          </TableCell>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.category}</TableCell>
                          <TableCell>{item.namaAHS}</TableCell>
                          <TableCell>{item.volume}</TableCell>
                          <TableCell>{item.satuanAHS}</TableCell>
                          <TableCell>
                            {/* INI YANG PERLU DIPERBAIKI - gunakan handleCoefficientChangeAdd */}
                            {isSelected ? (
                              <TextField
                                type="number"
                                size="small"
                                value={currentCoefficient}
                                onChange={(e) => {
                                  // PANGGIL handleCoefficientChangeAdd di sini
                                  handleCoefficientChangeAdd(
                                    item.id || "",
                                    e.target.value
                                  );
                                }}
                                onBlur={(e) => {
                                  // Optional: Validasi saat kehilangan fokus
                                  const value = parseFloat(e.target.value);
                                  if (isNaN(value) || value < 0 || value > 10) {
                                    Swal.fire({
                                      icon: "warning",
                                      title: "Nilai tidak valid",
                                      text: "Koefisien harus antara 0 dan 10",
                                    });
                                    // Reset ke nilai sebelumnya
                                    handleCoefficientChangeAdd(
                                      item.id || "",
                                      currentCoefficient
                                    );
                                  }
                                }}
                                inputProps={{
                                  min: -1,
                                  max: 10,
                                  step: 0.01,
                                  style: { width: "80px", textAlign: "right" },
                                }}
                              />
                            ) : (
                              <Typography variant="body2">
                                {currentCoefficient.toFixed(2)}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {`Rp ${item.hargaSatuan.toLocaleString("id-ID")}`}
                          </TableCell>
                          <TableCell>
                            {`Rp ${item.totalHarga.toLocaleString("id-ID")}`}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {/* Total Summary */}
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        <strong>Jumlah</strong>
                      </TableCell>
                      <TableCell>
                        <strong>
                          {`Rp ${totalRabValueAdd.toLocaleString("id-ID")}`}
                        </strong>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        PPN 11%
                      </TableCell>
                      <TableCell>
                        {`Rp ${Math.round(
                          totalRabValueAdd * 0.11
                        ).toLocaleString("id-ID")}`}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        <strong>Total + PPN</strong>
                      </TableCell>
                      <TableCell>
                        <strong>
                          {`Rp ${Math.round(
                            totalRabValueAdd * 1.11
                          ).toLocaleString("id-ID")}`}
                        </strong>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>

                <Typography variant="body2" sx={{ mt: 1 }}>
                  Terbilang: {terbilang(Math.round(totalRabValueAdd * 1.11))}{" "}
                  Rupiah
                </Typography>
              </>
            )}
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseAdd}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSaveAdd}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================================ POPUP Edit Bidding ======================================*/}
      <Dialog
        open={openEditBiddingDialog}
        onClose={() => setOpenEditBiddingDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle>
          {isEditing ? "Edit Bidding" : "Bidding Details"}
          <IconButton
            onClick={handleCloseEdit}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              {/* Profile Picture & Bidding ID */}
              <Grid item xs={6} sm={6}>
                {/* Form Input Section */}
                <Box sx={{ flex: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    PROJECT LISTING
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={projectOptions}
                    getOptionLabel={(option) => option.projectName || ""}
                    value={
                      projectOptions.find(
                        (opt) =>
                          opt.projectName === biddingDataEdit.projectName ||
                          opt.id === biddingDataEdit.projectName ||
                          opt.id === biddingDataEdit.projectListingId
                      ) || null
                    }
                    onChange={handleProjectChangeEdit}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name"
                        placeholder="Select project"
                        fullWidth
                        disabled={!isEditing}
                      />
                    )}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth
                    label="Client Name"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataEdit.clientName || ""}
                    sx={{ mb: 1 }}
                    name="clientName"
                    placeholder="Enter Client Name"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project ID / Refference"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataEdit.projectId || ""}
                    sx={{ mb: 1 }}
                    name="projectId"
                    placeholder="Enter Project ID / Refference"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Project Type"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataEdit.projectType || ""}
                    sx={{ mb: 1 }}
                    name="projectType"
                    placeholder="Enter Project Type"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Construction Phase"
                    margin="normal"
                    variant="outlined"
                    value={biddingDataEdit.constructionPhase || ""}
                    sx={{ mb: 1 }}
                    name="constructionPhase"
                    placeholder="Enter Construction Phase"
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mt: 51 }}
                  >
                    RAB
                  </Typography>
                  <Autocomplete
                    loading={loadingRabs}
                    fullWidth
                    options={rabOptions}
                    getOptionLabel={(option) => option.rabName || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      rabOptions.find(
                        (opt) =>
                          opt.id === biddingDataEdit.rabId ||
                          opt.rabName === biddingDataEdit.rabName
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setBiddingDataEdit((prev) => ({
                        ...prev,
                        rabId: newValue?.id || "",
                        rabName: newValue?.rabName || "",
                        rabValue: newValue
                          ? parseFloat(newValue.totalPrice) || 0
                          : 0,
                        startDate:
                          newValue?.project?.startDate || prev.startDate,
                        endDate: newValue?.project?.endDate || prev.endDate,
                        // Maintain other existing fields
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="RAB Name"
                        placeholder="Select RAB"
                        fullWidth
                        disabled={!isEditing}
                      />
                    )}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth
                    label="Bid Amount"
                    name="bidAmount"
                    type="number"
                    placeholder="Bid Amount"
                    sx={{ mt: 1 }}
                    value={biddingDataEdit.bidAmount || 0}
                    onChange={handleInputChangeEdit}
                    InputProps={{
                      // readOnly: true, // Make read-only if it should only come from RAB selection
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                    }}
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Submission Date"
                      format="YYYY-MM-DD"
                      value={
                        biddingDataEdit.submissionDate
                          ? dayjs(biddingDataEdit.submissionDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "submissionDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      disabled={!isEditing}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mt: 18, mb: 1 },
                          name: "submissionDate",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: biddingDataEdit.previewUrl
                        ? "2px solid #aaa"
                        : "2px dashed #aaa",
                      padding: 4,
                      borderRadius: "12px",
                      backgroundColor: "#fafafa",
                      textAlign: "center",
                      cursor: isEditing ? "pointer" : "default",
                      position: "relative",
                      opacity: isEditing ? 1 : 0.7,
                    }}
                    onClick={() =>
                      isEditing && editFileInputRef.current?.click()
                    }
                  >
                    {biddingDataEdit.previewUrl ? (
                      biddingDataEdit.previewUrl === "file_uploaded" ? (
                        <>
                          <PictureAsPdfIcon
                            fontSize="large"
                            color={isEditing ? "primary" : "disabled"}
                          />
                          <Typography variant="body2" mt={1}>
                            {generateDisplayPaymentFilename(
                              biddingDataEdit.projectName
                            )}
                          </Typography>
                          {biddingDataEdit.vendorProposalUrl && (
                            <Typography variant="caption" color="textSecondary">
                              File: {biddingDataEdit.vendorProposalUrl}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <>
                          <img
                            src={biddingDataEdit.previewUrl}
                            alt="File Preview"
                            style={{
                              width: "100%",
                              height: "auto",
                              borderRadius: "8px",
                              objectFit: "contain",
                              maxHeight: 180,
                            }}
                          />
                          {biddingDataEdit.vendorProposalUrl && (
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              mt={1}
                            >
                              Original: {biddingDataEdit.vendorProposalUrl}
                            </Typography>
                          )}
                        </>
                      )
                    ) : (
                      <>
                        <CloudUpload
                          fontSize="large"
                          color={isEditing ? "action" : "disabled"}
                        />
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          mt={1}
                        >
                          {isEditing
                            ? "Drag & drop or click to upload proposal file"
                            : "No proposal file uploaded"}
                        </Typography>
                      </>
                    )}

                    {/* Download and Delete Buttons */}
                    {biddingDataEdit.file && isEditing && (
                      <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (biddingDataEdit.vendorProposalUrl) {
                              handleDownload(biddingDataEdit.vendorProposalUrl);
                            }
                          }}
                        >
                          DOWNLOAD
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteProposalEdit();
                          }}
                        >
                          DELETE
                        </Button>
                      </Box>
                    )}

                    <input
                      hidden
                      accept=".pdf,.doc,.docx,.xls,.xlsx"
                      type="file"
                      ref={editFileInputRef}
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handleEditFileUpload(e.target.files[0]);
                        }
                      }}
                      disabled={!isEditing}
                    />
                    <Typography variant="caption" mt={1}>
                      Max size: 5MB (PDF, CSV/XLS/XLSX, WORD)
                    </Typography>
                  </Box>
                </Box>
                {/* <TextField
                  fullWidth
                  label="Koefisien"
                  name="koefisien"
                  type="number"
                  placeholder="Koefisien"
                  sx={{ mt: 5 }}
                  value={biddingDataEdit.koefisien || 1}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    inputProps: {
                      min: 0.1,
                      max: 10,
                      step: 0.1,
                    },
                    readOnly: !isEditing, // Hanya bisa diedit ketika mode editing aktif
                  }}
                  helperText="Nilai koefisien untuk mengadjust harga (default: 1)"
                  disabled={!isEditing} // Disable ketika tidak dalam mode editing
                /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* Map Placeholder */}
                <Typography variant="subtitle1" fontWeight="bold">
                  PROJECT ADDRESS
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter Project Address"
                  sx={{ textAlign: "left", mt: 1 }}
                  value={biddingDataEdit.projectAddress || ""}
                  name="projectAddress"
                  onChange={handleInputChangeEdit}
                  disabled
                />

                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    bgcolor: "inherit",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 2,
                  }}
                >
                  <MapPinLocation
                    latitude={biddingDataEdit.latitude}
                    longitude={biddingDataEdit.longitude}
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setBiddingDataEdit((prev) => ({
                          ...prev,
                          latitude: lat.toString(),
                          longitude: lng.toString(),
                        }));
                      }
                    }}
                    disabled
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="Input Latitude"
                    name="latitude"
                    placeholder="Enter latitude"
                    value={biddingDataEdit.latitude || ""}
                    onChange={handleInputChangeAdd}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Input Longitude"
                    name="longitude"
                    placeholder="Enter longitude"
                    value={biddingDataEdit.longitude || ""}
                    onChange={handleInputChangeEdit}
                    disabled
                  />
                </Box>

                <TextField
                  fullWidth
                  label="Country"
                  margin="normal"
                  variant="outlined"
                  placeholder="Enter Bidding Region"
                  value={biddingDataEdit.biddingRegion || ""}
                  sx={{ mb: 1 }}
                  name="biddingRegion"
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="City"
                  name="biddingCity"
                  placeholder="Enter Bidding City"
                  sx={{ mb: 1 }}
                  value={biddingDataEdit.biddingCity || ""}
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="District"
                  name="biddingDistrict"
                  placeholder="Enter Bidding District"
                  sx={{ mb: 1 }}
                  value={biddingDataEdit.biddingDistrict || ""}
                  onChange={handleInputChangeEdit}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Rab Value"
                  name="rabValue"
                  placeholder="Rab Value"
                  sx={{ mt: 13, mb: 1 }}
                  value={biddingDataEdit.rabValue || 0}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true, // Make read-only if it should only come from RAB selection
                    startAdornment: (
                      <InputAdornment position="start">Rp</InputAdornment>
                    ),
                  }}
                  disabled
                />
                <TextField
                  fullWidth
                  label="Start Date"
                  name="startDate"
                  placeholder="Start date"
                  sx={{ mb: 1 }}
                  value={biddingDataEdit.startDate || ""}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
                <TextField
                  fullWidth
                  label="End Date"
                  name="endDate"
                  placeholder="End date"
                  sx={{ mb: 1 }}
                  value={biddingDataEdit.endDate || ""}
                  onChange={handleInputChangeEdit}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
                <TextField
                  select
                  fullWidth
                  label="Project Process"
                  name="projectProcess"
                  placeholder="Enter Project Process"
                  sx={{ mt: 9.3, mb: 1 }}
                  value={biddingDataEdit.projectProcess}
                  onChange={handleInputChangeEdit}
                  error={!biddingDataEdit.projectProcess}
                  helperText={
                    !biddingDataEdit.projectProcess ? "Mandatory Field" : ""
                  }
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Swadaya">Swadaya</MenuItem>
                  <MenuItem value="Partial">Partial</MenuItem>
                  <MenuItem value="Full Vendor">Full Vendor</MenuItem>
                </TextField>
                {/* Vendor Names Section */}
                {/* Header */}
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ mt: 2 }}
                    >
                      Vendor Names
                      {biddingDataEdit.vendorNames.every((v) => !v) && (
                        <FormHelperText error sx={{ ml: 1 }}>
                          Mandatory Field
                        </FormHelperText>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ mt: 2 }}
                    >
                      Vendor Values
                      {biddingDataEdit.vendorProjectValue.every((v) => !v) && (
                        <FormHelperText error sx={{ ml: 1 }}>
                          Mandatory Field
                        </FormHelperText>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>

                {/* List Vendor Fields */}
                {biddingDataEdit.vendorNames.map((vendorId, index) => {
                  const vendor = vendors.find((v) => v.vendorId === vendorId);
                  const projectValue = Array.isArray(
                    biddingDataEdit.vendorProjectValue
                  )
                    ? biddingDataEdit.vendorProjectValue[index] || ""
                    : index === 0
                    ? biddingDataEdit.vendorProjectValue || ""
                    : "";

                  return (
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      key={index}
                      sx={{ mb: 1 }}
                    >
                      {/* Vendor Selection */}
                      <Grid item xs={6}>
                        <Autocomplete
                          options={vendors}
                          getOptionLabel={(option) => option.vendorName || ""}
                          value={vendor || null}
                          onChange={(_, newValue) => {
                            handleVendorChangeEdit(
                              index,
                              newValue?.vendorId || ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Vendor"
                              fullWidth
                              margin="dense"
                              disabled={!isEditing}
                              error={!vendorId && index === 0}
                              helperText={
                                !vendorId && index === 0
                                  ? "Please select at least one vendor"
                                  : ""
                              }
                            />
                          )}
                          disabled={!isEditing || loadingVendors}
                        />
                      </Grid>

                      {/* Project Value */}
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label="Project Value"
                          placeholder="Enter Value"
                          value={projectValue}
                          onChange={(e) =>
                            handleProjectValueChangeEdit(index, e.target.value)
                          }
                          error={!projectValue && index === 0}
                          helperText={
                            !projectValue && index === 0
                              ? "Please enter project value"
                              : ""
                          }
                          disabled={!isEditing}
                        />
                      </Grid>

                      {/* Add/Remove Buttons */}
                      <Grid item xs={2}>
                        {index === biddingDataEdit.vendorNames.length - 1 ? (
                          <IconButton
                            onClick={addVendorFieldEdit}
                            color="primary"
                            disabled={!isEditing}
                          >
                            <Add />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() => removeVendorFieldEdit(index)}
                            color="error"
                            disabled={!isEditing}
                          >
                            <DeleteOutline />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
                <TextField
                  select
                  fullWidth
                  label="Bidding Stauts"
                  name="status"
                  placeholder="Enter Bidding Stauts"
                  sx={{ mb: 1 }}
                  value={biddingDataEdit.status}
                  onChange={handleInputChangeEdit}
                  error={!biddingDataEdit.status}
                  helperText={!biddingDataEdit.status ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>
                    Select item
                  </MenuItem>
                  <MenuItem value="Submit">Submit</MenuItem>
                  <MenuItem value="Review">Review</MenuItem>
                  <MenuItem value="Shortlisted">Shortlisted</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                  <MenuItem value="Awarded">Awarded</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              RAB Review
            </Typography>

            <Box textAlign={"right"} sx={{ mb: 2 }}>
              <Button
                onClick={exportRabDetailToPDFBidding}
                variant="outlined"
                startIcon={<PictureAsPdfIcon />}
                color="error"
                size="small"
              >
                Export PDF
              </Button>
              <Button
                onClick={exportRabDetailToExcelBidding}
                variant="outlined"
                startIcon={<Download />}
                color="success"
                size="small"
                sx={{ ml: 1 }}
              >
                Export Excel
              </Button>
            </Box>

            {loadingRabReview ? (
              <Typography>Loading RAB details...</Typography>
            ) : rabReviewDataEdit.length === 0 ? (
              <Typography>No RAB details available</Typography>
            ) : (
              <>
                <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
                  {selectedRabItemsEdit.length} of {rabReviewDataEdit.length}{" "}
                  items selected
                </Typography>
                <Table size="small" sx={{ mb: 2 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selectedRabItemsEdit.length > 0 &&
                            selectedRabItemsEdit.length <
                              rabReviewDataEdit.length
                          }
                          checked={
                            rabReviewDataEdit.length > 0 &&
                            selectedRabItemsEdit.length ===
                              rabReviewDataEdit.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              // SELECT ALL: Gunakan nilai yang sudah ada di adjustment
                              const allIds = rabReviewDataEdit.map(
                                (item) => item.id || ""
                              );

                              // Pertahankan coefficients yang sudah ada, untuk yang baru gunakan nilai dari adjustment
                              const newCoefficients = {
                                ...itemCoefficientsEdit,
                              };
                              allIds.forEach((id) => {
                                if (newCoefficients[id] === undefined) {
                                  // Ambil nilai koefisien dari adjustment yang sudah ada
                                  const adjustment = biddingAdjustments.find(
                                    (adj) => adj.rabDetailId === id
                                  );
                                  if (adjustment) {
                                    newCoefficients[id] =
                                      parseFloat(adjustment.koefisien) || 0.1;
                                  } else {
                                    const item = rabReviewDataEdit.find(
                                      (rabItem) => rabItem.id === id
                                    );
                                    newCoefficients[id] =
                                      item?.overheadKoefisien || 0.1;
                                  }
                                }
                              });

                              setSelectedRabItemsEdit(allIds);
                              setItemCoefficientsEdit(newCoefficients);
                            } else {
                              // UNSELECT ALL: Hanya hapus selection, TETAP PERTAHANKAN coefficients
                              setSelectedRabItemsEdit([]);
                              // JANGAN reset itemCoefficientsEdit biar nilai tetap ada
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>No</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Volume</TableCell>
                      <TableCell>Unit</TableCell>
                      <TableCell>New Coefficient</TableCell>
                      <TableCell>Unit Price</TableCell>
                      <TableCell>Total Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adjustedRabReviewDataEdit.map((item, index) => {
                      const isSelected = selectedRabItemsEdit.includes(
                        item.id || ""
                      );

                      // SELALU gunakan data dari adjustedRabReviewDataEdit yang sudah di-update
                      const currentCoefficient =
                        itemCoefficientsEdit[item.id || ""] !== undefined
                          ? itemCoefficientsEdit[item.id || ""]
                          : item.overheadKoefisien || 0.1;

                      const safeCoefficient = isNaN(currentCoefficient)
                        ? 0.1
                        : currentCoefficient;

                      // GUNAKAN NILAI LANGSUNG DARI adjustedRabReviewDataEdit
                      const totalPrice = item.totalHarga || 0;
                      const unitPrice = item.hargaSatuan || 0;

                      return (
                        <TableRow key={item.id || index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isSelected}
                              onChange={(e) => {
                                handleRabItemSelectEdit(
                                  item.id || "",
                                  e.target.checked
                                );
                              }}
                              disabled={!isEditing} // Disable checkbox jika tidak dalam mode edit
                            />
                          </TableCell>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.category}</TableCell>
                          <TableCell>{item.namaAHS}</TableCell>
                          <TableCell>{item.volume}</TableCell>
                          <TableCell>{item.satuanAHS}</TableCell>
                          <TableCell>
                            {isSelected && isEditing ? (
                              <TextField
                                type="number"
                                size="small"
                                value={safeCoefficient}
                                onChange={(e) => {
                                  const newValue = parseFloat(e.target.value);
                                  handleCoefficientChangeEdit(
                                    item.id || "",
                                    newValue
                                  );
                                }}
                                inputProps={{
                                  min: -1,
                                  max: 10,
                                  step: 0.01,
                                  style: { width: "80px", textAlign: "right" },
                                }}
                              />
                            ) : (
                              <Typography variant="body2">
                                {safeCoefficient.toFixed(2)}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {`Rp ${unitPrice.toLocaleString("id-ID")}`}
                          </TableCell>
                          <TableCell>
                            {`Rp ${totalPrice.toLocaleString("id-ID")}`}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {/* Total Summary - GUNAKAN totalRabValueEdit yang sudah di-update */}
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        <strong>Jumlah</strong>
                      </TableCell>
                      <TableCell>
                        <strong>
                          {`Rp ${totalRabValueEdit.toLocaleString("id-ID")}`}
                        </strong>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        PPN 11%
                      </TableCell>
                      <TableCell>
                        {`Rp ${Math.round(
                          totalRabValueEdit * 0.11
                        ).toLocaleString("id-ID")}`}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={8} align="right">
                        <strong>Total + PPN</strong>
                      </TableCell>
                      <TableCell>
                        <strong>
                          {`Rp ${Math.round(
                            totalRabValueEdit * 1.11
                          ).toLocaleString("id-ID")}`}
                        </strong>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>

                <Typography variant="body2" sx={{ mt: 1 }}>
                  Terbilang: {terbilang(Math.round(totalRabValueEdit * 1.11))}{" "}
                  Rupiah
                </Typography>
              </>
            )}
          </Box>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button
              onClick={() => setIsEditing(true)}
              variant="contained"
              color="primary"
              sx={{ width: 120 }}
            >
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
                sx={{ width: 120 }}
              >
                CANCEL
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
                sx={{ width: 120 }}
              >
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default BiddingListPage;
